export const ptLangDashboard = {
  common: {
    you: 'Você',
    post: 'Publicação',
    article: 'Artigo',
    create: 'Criar',
    message: 'Mensagem',
    popular: 'Popular',
    emptyIntegrations: 'Você precisa adicionar integrações primeiro',
    categories: 'Categorias',
    edit: 'Editar',
    share: 'Compartilhar',
    plan: 'Plano',
    sort: 'Ordenar',
    addArticle: 'Adicionar artigo',
    articles: 'Artigos',
    users: 'usuários',
    scans: 'escaneamentos',
    clicks: 'cliques',
    copy: 'Copiar',
    customize: 'Personalizar',
    link: 'link',
    save: 'Salvar',
    uploadFile: 'Enviar Arquivo',
    customImage: 'Imagem Personalizada',
    customImageTooltip: 'Enviar imagem personalizada',
    size: 'Tamanho',
    sizeTooltip: 'Arraste o controle para definir o tamanho',
    auto: 'Auto',
    rectangle: 'Retângulo',
    custom: 'Personalizado',
    clean: 'Limpar',
    cleaning: 'Limpando',
    download: 'Baixar',
    downloading: 'Baixando',
    preview: 'PRÉ-VISUALIZAR',
    cover: 'Capa',
    coverTooltip: 'Envie uma foto de capa',
    title: 'Título',
    new: 'Novo',
    pro: 'Pro',
    free: 'Grátis',
    limit: 'Limite',
    websites: 'sites',
    site: 'Site',
    apiKey: 'API Key',
    name: 'Nome',
    passwordChange: 'Alterar senha',
    draft: 'Rascunho',
    page: 'Página',
    areYouSure: 'Tem certeza?',
    drop: 'Soltar',
    video: 'vídeo',
    image: 'imagem',
    chooseFile: 'Escolher arquivo',
    nothingFound: 'Nada Encontrado',
    enterCorrectLink: 'Insira um link correto',
    off: 'Desligado',
    disconnect: 'DESCONECTAR',
    connect: 'CONECTAR',
    copied: 'Copiado',
    saved: 'Salvo',
    lostConnection: 'Conexão perdida',
    addedCategory: 'Categoria adicionada',
    none: 'Nenhum',
    left: 'Esquerda',
    right: 'Direita',
    solid: 'Sólido',
    double: 'Duplo',
    welcome: 'Bem-vindo',
    category: 'Categoria',
    product: 'Produto',
    website: 'Site',
    items: 'Itens',
    square: 'Quadrado',
    round: 'Redondo',
    border: 'Borda',
    shadow: 'Sombra',
    soft: 'Suave',
    hard: 'Forte',
    block: 'Bloco',
    primary: 'Primário',
    additional: 'Adicional',
    normal: 'Normal',
    bold: 'Negrito',
    uploadVideo: 'Enviar vídeo',
    compact: 'Compacto',
    card: 'Cartão',
    top: 'Topo',
    center: 'Centro',
    bottom: 'Inferior',
    button: 'Botão',
    addNewItem: 'Adicionar novo item',
    price: 'Preço',
    priceCaption: 'Adicione o preço do seu produto',
    oldPrice: 'Preço antigo',
    oldPriceCaption: 'O preço antigo será riscado',
    areYouSureDeleteItem: 'Tem certeza de que deseja remover este item?',
    add: 'Adicionar',
    active: 'Ativo',
    isActive: 'está ativo',
    isDisabled: 'está desativado',
    uploadImage: 'Enviar imagem',
    design: 'Design',
    addAccount: 'Adicionar conta',
    hey: 'Olá',
    activeBackground: 'Fundo ativo',
    activeText: 'Texto ativo',
    connectDomain: 'Conectar Domínio',
    shortLink: 'Link Curto',
    appearanceSaved: 'Aparência salva!',
    blockAdded: 'Bloco adicionado!',
    comingSoon: 'Em breve',
    easyMoney: 'Dinheiro fácil',
    content: 'Conteúdo',
    audience: 'Público',
    view: 'Visualizar',
    delete: 'Excluir',
    file: 'Arquivo',
    type: 'Tipo',
    from: 'De',
    to: 'Para',
    fullName: 'Nome completo',
    lastTimeUsed: 'Último uso',
    noMediaFiles: 'Sem arquivos de mídia ainda...',
    withdraw: 'Sacar',
    congrats: 'Parabéns!',
    makeMoneyOnline: 'Ganhe dinheiro online!',
  },
  sort: {
    title: 'Ordenar',
    search: 'Buscar',
    default: 'Ordenação padrão',
    dateNew: 'Data: Mais Recente para Mais Antigo',
    dateOld: 'Data: Mais Antigo para Mais Recente',
    priceLow: 'Preço: Menor para Maior',
    priceHigh: 'Preço: Maior para Menor',
    nameA: 'Nome: A a Z',
    nameZ: 'Nome: Z a A',
  },
  emailMenu: {
    broadcasts: 'Transmissões',
    automations: 'Automações',
    templates: 'Modelos',
    settings: 'Configurações',
    noEmails: 'Nenhum e-mail ainda',
    newBroadcast: 'Novas Transmissões',
  },
  aiContent: {
    title: 'Crie seu primeiro conteúdo com IA!',
    text: 'Planeje e publique conteúdo em todas as redes sociais de uma vez!',
    create: 'Criar conteúdo com IA',
  },
  pageDesign: {
    page: 'Design da página',
    image: 'Imagem',
  },
  toolsMenu: {
    title: 'Ferramentas',
    account: 'Conta',
    instantPages: 'Páginas Instantâneas',
    instantPagesText: 'Páginas independentes de carregamento rápido',
    agents: 'Agentes',
    agentsText: 'Assistentes de IA que gerenciam seu perfil',
    socialPlanner: 'Planejador Social',
    socialPlannerText: 'Agendamento de conteúdo e inspiração',
    emailMarketing: 'Email Marketing',
    emailMarketingText: 'Aumente sua lista de contatos',
    smartReply: 'Resposta Inteligente',
    smartReplyText: 'Envie comentários e mensagens automáticas',
    linkShortener: 'Encurtador de Links',
    linkShortenerText: 'Encurte URLs longas',
    posts: 'Publicações',
    postsText: 'Crie e gerencie publicações',
    blog: 'Blog',
    blogText: 'Crie e gerencie artigos do blog',
  },
  insideMenu: {
    planner: 'Planejador',
    aiContent: 'Conteúdo IA',
    aiPosts: 'Posts com IA',
    postIdeas: 'Ideias de Posts',
    contentPlanner: 'Planejador de Conteúdo',
    aiImages: 'Imagens com IA',
    brandProjects: 'Projetos de Marca',
    aiVideo: 'Vídeo IA',
    integrations: 'Integrações',
    products: 'Produtos',
    orders: 'Pedidos',
    payments: 'Pagamentos',
    links: 'Links',
    qrCodes: 'Códigos QR',
  },
  orders: {
    title: 'Pedidos',
    empty: 'Você ainda não tem nenhum pedido',
    all: 'Todos os pedidos',
    shop: 'Loja',
    digital: 'Produtos digitais',
    appointments: 'Agendamentos',
    services: 'Serviços',
    donations: 'Doações',
  },
  discounts: {
    title: 'Descontos',
    newDiscount: '+ Novo desconto',
    code: 'Código',
    titleCol: 'Título',
    type: 'Tipo',
    value: 'Valor',
    status: 'Status',
    used: 'Usado',
    actions: 'Ações',
    statusAll: 'Todos os status',
    statusActive: 'Ativo',
    statusExpired: 'Expirado',
    statusScheduled: 'Agendado',
    statusInactive: 'Inativo',
    searchPlaceholder: 'Pesquisar por código ou título...',
    clearFilters: 'Limpar filtros',
    emptyTitle: 'Ainda não há descontos',
    emptySubtitle: 'Crie seu primeiro código promocional para oferecer descontos nos seus produtos',
    createDiscount: 'Criar desconto',
    createTitle: 'Criar desconto',
    editTitle: 'Editar desconto',
    fieldTitle: 'Título',
    fieldTitlePlaceholder: 'ex. Promoção de primavera',
    fieldCode: 'Código',
    fieldCodePlaceholder: 'ex. SAVE20',
    generate: 'Gerar',
    sectionDiscount: 'Desconto',
    fieldType: 'Tipo',
    typePercentage: 'Percentagem',
    typeFixed: 'Valor fixo',
    fieldValue: 'Valor',
    sectionConditions: 'Condições (opcional)',
    appliesTo: 'Aplica-se a',
    appliesToAll: 'Todos os produtos',
    appliesToShop: 'Loja',
    appliesToDigital: 'Digital',
    appliesToCourses: 'Cursos',
    appliesToServices: 'Serviços',
    appliesToEvents: 'Eventos',
    minOrderAmount: 'Valor mínimo do pedido ($)',
    maxDiscountAmount: 'Valor máximo de desconto ($) — 0 = sem limite',
    sectionLimits: 'Limites',
    usageLimit: 'Limite total de uso — 0 = sem limite',
    usageLimitPerUser: 'Limite por cliente — 0 = sem limite',
    sectionSchedule: 'Agendamento',
    startDate: 'Data de início — vazio = começa agora',
    endDate: 'Data de fim — vazio = sem expiração',
    active: 'Ativo',
    cancel: 'Cancelar',
    save: 'Salvar desconto',
    createdSuccess: 'Desconto criado',
    updatedSuccess: 'Desconto atualizado',
    deletedSuccess: 'Desconto excluído',
    loadError: 'Falha ao carregar descontos',
    saveError: 'Falha ao salvar o desconto',
    deleteError: 'Falha ao excluir o desconto',
  },
  donation: {
    chooseSmiles: 'Escolher emojis',
    item: 'Item',
    itemTitle: 'Título do item de doação',
    price: 'Preço',
    thanksMessagePlaceholder: 'Muito obrigado',
    thanksMessage: 'Mensagem de agradecimento',
    thanksMessageCaption: 'A mensagem de agradecimento será exibida para seus fãs após a doação',
    addDonation: 'Adicionar doação',
    addAmount: '+ Adicionar valor',
    buttonTitle: 'Título do botão',
    buttonTitleCaption: 'Título do botão de doação',
    acceptDonations: 'Aceitar doações',
    donationsType: 'Doações',
    tips: 'Gorjetas',
    type: 'Tipo',
    addAnotherAmount: '+ Adicionar outro valor',
  },
  blog: {
    empty: 'Você ainda não tem um blog',
  },
  apps: {
    empty: 'Você ainda não tem aplicativos',
  },
  payments: {
    title: 'Pagamentos',
    text: 'Você ainda não tem nenhuma transação',
    single: 'Pagamentos únicos',
    subscriptions: 'Assinaturas',
    wallet: 'Carteira',
    connectPromo: 'Conecte sua conta Stripe ou PayPal à sua página UniLink e receba todos os pagamentos na sua carteira.',
    connectSystem: 'Conectar sistema de pagamento',
    manageCards: 'Gerenciar seus cartões',
    addNewCard: 'Adicionar novo cartão',
    editCard: 'Editar informações do cartão',
    addCard: 'Adicionar informações do cartão',
    cardHolder: 'Nome do Titular do Cartão',
    cardHolderNecessary: 'É necessário',
    withdrawalSuccess: 'Seu saque foi enviado com sucesso!',
    withdrawalError: 'Algo deu errado, tente novamente mais tarde.',
    change: 'Alterar',
  },
  store: {
    emptyTitle: 'Você ainda não tem nenhum produto',
    emptyText: 'Comece adicionando seu primeiro produto',
    emptyButton: 'Adicionar produto',
    createFirstProduct: 'Crie seu primeiro produto',
    startAdding: 'Comece adicionando seus produtos favoritos, bens digitais ou serviços. Um espaço onde você pode vender e promover tudo o que oferece.',
    activate: 'Ativar Loja',
    empty: 'Você ainda não tem produtos',
    products: 'Produtos',
    addProducts: 'Adicionar produtos',
    whatDoYouWant: 'O que você quer vender?',
    externalProduct: 'URL de produto externo',
    createOwnProduct: 'Criar seu próprio produto',
    shop: 'Loja',
    shopText: 'Venda produtos físicos e digitais',
    digital: 'Produtos digitais',
    digitalText: 'Venda um Download Digital',
    course: 'Curso ou Tutorial',
    courseText: 'Adicione curso ou tutorial ao site',
    service: 'Serviços',
    serviceText: 'Adicione serviços para seus clientes',
    appointment: 'Agendamentos',
    appointmentText: 'Permita que visitantes agendem horários no seu calendário',
    event: 'Eventos ou Ingressos',
    eventText: 'Crie eventos e convide seu público',
    tips: 'Gorjetas',
    tipsText: 'Deixe uma gorjeta para seus criadores favoritos',
    donation: 'Doações',
    donationText: 'Faça uma doação',
    membership: 'Assinatura',
    membershipText: 'Adicione assinatura ao site',
    links: 'Link externo',
    linksText: 'Adicione link externo para qualquer site',
    coupon: 'Cupom',
    couponText: 'Adicione cupom para seu site',
    singleProduct: 'Produto Único',
    singleProductText: 'Venda um único produto com checkout simples',
    booking: 'Reservas',
    bookingText: 'Permita que visitantes reservem seus espaços ou propriedades',
    rental: 'Aluguel',
    rentalText: 'Liste itens para alugar com disponibilidade e preços',
    add: 'Adicionar',
    manageStore: 'Gerenciar Loja',
    displayLast: 'Exibir último produto',
  },
  products: {
    info: 'Informações',
    uploadCover: 'Envie uma foto de capa, depois forneça um título e descrição',
    thumbnail: 'Miniatura',
    thumbnailError: 'Por favor, adicione uma miniatura',
    title: 'Título',
    titleTooltip: 'Insira o nome do seu produto',
    shortDescription: 'Descrição curta',
    shortDescriptionTooltip: 'Insira uma descrição curta do seu produto',
    description: 'Descrição',
    descriptionTooltip: 'Insira a descrição do seu produto',
    descriptionTooltipExtra: 'Descrição opcional de características, tipos, cor, tamanhos do produto, etc.',
    price: 'Preço',
    priceTooltip: 'Insira o preço do seu produto',
    oldPrice: 'Preço antigo',
    oldPriceTooltip: 'O preço antigo será riscado',
    category: 'Categoria',
    categoryTooltip: 'Escolha a categoria do seu produto',
    image: 'Imagem',
    imageTooltip: 'Envie uma imagem para seu produto',
    groups: 'Grupos',
    rate: 'Avaliação',
    rateTooltip: 'Insira a avaliação do seu produto',
    buttonTitle: 'Título do botão',
    buttonTitleTooltip: 'Insira o título do botão do seu produto',
    limitQuantity: 'Limitar Quantidade',
    itemsLeft: 'Itens restantes',
    itemsLeftTooltip: 'Itens do seu produto',
    attachments: 'Anexos',
    addAttachments: 'Adicione anexos aos seus produtos',
    addNewAttachment: 'Adicionar novo item',
    file: 'Arquivo',
    uploadFile: 'Enviar arquivo',
    uploadCoverTitle: 'Enviar capa',
    optionalDescription: 'Descrição opcional de características, tipos, cor, tamanhos do produto, etc.',
    customReviews: 'Avaliações personalizadas',
    addCustomReviews: 'Adicione avaliações aos seus produtos',
    name: 'Nome',
    nameTooltip: 'Insira o nome do seu cliente',
    comment: 'Comentário',
    commentTooltip: 'Insira o comentário do seu cliente',
    rateTooltipCustomer: 'Avaliação do cliente',
    imageTooltipCustomer: 'Envie a imagem do seu cliente',
    displayPriceOnPreview: 'Exibir preço na pré-visualização',
    displayDetailsOnPreview: 'Exibir detalhes na pré-visualização',
    postOnSocials: 'Publicar nas Redes Sociais',
    sendAnEmail: 'Enviar um E-mail',
    highlights: 'Destaques',
    listProductSetup: 'Liste o produto e configure seu bloco de loja',
    whereToSell: 'Onde você gostaria de vender este produto?',
    youHaveProducts: 'Você tem {count} produtos',
    shareThisProduct: 'Compartilhar este produto',
    shareAProduct: 'Compartilhar um produto',
    monetizeWays: 'Diferentes formas de monetizar no Unilink',
    addProductToProfile: 'Adicionar um {title} ao seu perfil',
    productPage: 'Página do produto',
    setUpPayments: 'Configure seus pagamentos',
    connectPaymentMethods: 'Conecte seus métodos de pagamento para começar a ganhar dinheiro no Unilink',
    addPaymentMethod: 'Adicione um método de pagamento {type} para receber pagamentos dos seguidores',
    withdrawAttempt: 'Esta é uma tentativa de cobrança de dívida e qualquer informação será usada para esse fim.',
    withdrawSuccess: 'Seu saque foi enviado com sucesso!',
    yourVisitorsPay: 'Seus visitantes pagarão primeiro e depois serão direcionados para seu {method}',
    emailAddress: 'endereço de e-mail',
    calendlyLink: 'link do Calendly',
  },
  posts: {
    posts: 'Publicações',
    title: 'Crie sua primeira publicação',
    description: 'Publicações são onde você cria automações de chat em um formato fácil e visual. Experimente algumas automações que recomendamos com base nos seus objetivos',
    activate: 'Ativar Publicações',
    managePosts: 'Gerenciar Publicações',
    postsTab: 'Aba de Publicações',
    displayLast: 'Exibir últimas publicações',
    tabNavigation: 'Configurações de navegação por abas',
    createFirstPost: 'Crie sua primeira publicação social!',
    autoPostsText: 'Planeje e publique conteúdo em todas as redes sociais de uma vez!',
    createPost: 'Criar publicação',
  },
  messages: {
    title: 'Mensagens',
    empty: 'Sem Mensagens',
    addText: 'Adicione um botão de mensagem ao bloco Cabeçalho, permitindo que os usuários enviem facilmente uma mensagem para você.',
    addButton: 'Adicionar botão de Mensagem',
  },
  smartReply: {
    title: 'Resposta Inteligente',
    clicks: 'cliques',
    createTitle: 'Crie sua primeira Resposta Inteligente!',
    text: 'Use DMs automáticas do Instagram para compartilhar links automaticamente com seu público!',
    createButton: 'Criar Resposta Inteligente',
  },
  shortLinks: {
    title: 'Encurtador de Links',
    addLink: 'Adicionar link',
    name: 'Nome',
    slug: 'Slug',
    slugTooltip: 'Você pode alterar o Slug clicando no botão de edição',
    destinationUrl: 'URL de Destino',
    metadata: 'Metadados',
    utmTags: 'Tags UTM',
    customizeMetadata: 'Personalize os metadados do link',
    metaTitle: 'Título',
    metaDescription: 'Descrição',
    favicon: 'Favicon',
    imagePreview: 'Pré-visualização da imagem',
    addUtm: 'Adicionar tags UTM ao link (opcional)',
    utmCampaign: 'UTM Campaign',
    utmMedium: 'UTM Medium',
    utmSource: 'UTM Source',
    utmTerm: 'UTM Term',
    utmContent: 'UTM Content',
    utmId: 'UTM Id',
    utmPlacement: 'UTM Placement',
    utmCreative: 'UTM Creative',
    pasteLink: 'Cole seu link longo aqui',
    shorten: 'Encurtar link',
    edit: 'Editar detalhes do item',
  },
  audience: {
    title: 'Público',
    total: 'Total',
    totalMembers: 'Total de Membros do Público',
    totalContacts: 'Total de Contatos',
    forms: 'Formulários',
    subscribers: 'Assinantes',
    customers: 'Clientes',
    noAudienceMembers: 'Sem Contatos',
    emptyAudienceMembers: 'Adicione novos contatos clicando no botão',
    addAudienceMember: 'Adicionar Contato',
    noSubscribers: 'Sem Assinantes',
    emptySubscribers: 'Adicione novos assinantes adicionando blocos ao seu Link na Bio',
    addDataCollect: 'Adicionar bloco de Coleta de Dados',
    noResponses: 'Sem Respostas',
    emptyResponses: 'Adicione novas respostas adicionando blocos ao seu Link na Bio',
    addFormBlock: 'Adicionar bloco de Formulário',
    noCustomers: 'Sem Clientes',
    emptyCustomers: 'Adicione novos clientes adicionando produtos ao seu Link na Bio',
    addProduct: 'Adicionar Produto',
    addContactModal: {
      title: 'Adicionar novo contato',
      name: 'Nome',
      nameTooltip: 'Insira o nome do seu contato',
      email: 'E-mail',
      emailTooltip: 'Insira o endereço de e-mail do seu contato',
      phone: 'Telefone',
      phoneTooltip: 'Insira o número de telefone do seu contato',
      telegram: 'Telegram',
      telegramTooltip: 'Insira o nome de usuário ou URL do Telegram do seu contato',
      whatsapp: 'WhatsApp',
      whatsappTooltip: 'Insira o número de WhatsApp do seu contato',
      instagram: 'Instagram',
      instagramTooltip: 'Insira o nome de usuário ou URL do Instagram do seu contato',
      messenger: 'Messenger',
      messengerTooltip: 'Insira o nome de usuário ou URL do Messenger do seu contato',
      viber: 'Viber',
      viberTooltip: 'Insira o número de Viber do seu contato',
      address: 'Endereço',
      addressTooltip: 'Insira o endereço do seu contato',
      add: 'Adicionar',
    },
    search: {
      search: 'Buscar',
      error: 'Caractere inválido inserido no campo de busca',
      notFound: 'Nenhum resultado encontrado',
    },
  },
  auth: {
    logIn: 'Entrar',
    logInWith: 'Entrar com',
    signIn: 'Fazer login',
    signInWith: 'Cadastrar com',
    email: 'E-mail',
    password: 'Senha',
    notHaveAccount: 'Não tem uma conta?',
    createAccount: 'Criar uma nova Conta',
    createYourAccount: 'Crie sua Conta',
    signUp: 'Cadastrar',
    haveAccount: 'Se você já tem uma conta',
    or: 'ou',
    reset: 'Redefinir',
    resetPassword: 'Redefinir senha',
    resetTitle: 'O link de recuperação foi enviado para seu e-mail',
    goToHome: 'Ir para a Página Inicial',
    byClicking: 'Ao clicar em',
    youAreAgree: 'você concorda com os',
    terms: 'Termos de Serviço',
    andConfirm: 'e nossa',
    usagePolicy: 'Política de Uso',
    signInGoogle: 'Entrar com Google',
    forgotPassword: 'Esqueceu a senha?',
  },
  menu: {
    moreApps: 'Mais aplicativos',
    account: 'Conta',
    more: 'Mais',
    storyWidget: 'Embed Stories',
    integrations: 'Integrações',
    socialAccounts: 'Contas sociais',
    aiContent: 'Conteúdo IA',
    aiPosts: 'Posts com IA',
    postIdeas: 'Ideias de Posts',
    contentPlanner: 'Planejador de Conteúdo',
    aiImages: 'Imagens com IA',
    aiVideo: 'Vídeo com IA',
    planner: 'Planejador',
    customers: 'Clientes',
    subscribers: 'Assinantes',
    forms: 'Formulários',
    allAudience: 'Todo o público',
    payments: 'Pagamentos',
    orders: 'Pedidos',
    products: 'Produtos',
    events: 'Eventos',
    appointments: 'Agendamentos',
    discounts: 'Descontos',
    instantPages: 'Páginas Instantâneas',
    openInNewTab: 'Abrir em nova aba',
    linkInBio: 'Link na Bio',
    linkInBioApps: 'Link na Bio',
    website: 'Site',
    store: 'Loja',
    audience: 'Público',
    emailMarketing: 'Email Marketing',
    postPlaner: 'Planejador de Posts',
    posts: 'Publicações',
    agents: 'Agentes',
    community: 'Comunidade',
    profileHealth: 'Saúde do Perfil',
    socialPlanner: 'Planejador Social',
    shortLinks: 'Encurtador de Links',
    views: 'Visualizações',
    clicks: 'Cliques',
    allWebsites: 'Todos os Sites',
    createNewAccount: 'Criar nova conta',
    createNewWebsite: 'Criar um novo perfil',
    tools: 'Ferramentas',
    borderGenerator: 'Gerador de Bordas',
    yourPlan: 'Seu plano:',
    upgrade: 'Atualizar',
    accountSettings: 'Configurações da conta',
    manageWebsites: 'Gerenciar perfis',
    updates: 'Atualizações',
    autoUpdate: 'Atualização automática',
    logOut: 'Sair',
    myPages: 'Minhas Páginas',
    design: 'Design',
    heading: 'Título',
    analytics: 'Análises',
    settings: 'Configurações',
    open: 'Abrir',
    language: 'Idioma',
    movePage: 'Mover Página',
    editBlock: 'Editar Bloco',
    renameBlock: 'Renomear Bloco',
    rename: 'Renomear',
    deleteBlock: 'Excluir Bloco',
    archiveBlock: 'Arquivar Bloco',
    archive: 'Arquivar',
    scheduleBlock: 'Agendar Bloco',
    copyBlock: 'Copiar Bloco',
    dublicateBlock: 'Duplicar Bloco',
    content: 'Conteúdo',
    preview: 'Pré-visualizar',
    copy: 'Copiar',
    moveBlock: 'Mover Bloco',
    move: 'Mover',
    edit: 'Editar',
    delete: 'Excluir',
    schedule: 'Agendar',
    dublicate: 'Duplicar',
    smartReply: 'Resposta Inteligente',
    marketing: 'Marketing',
    appInBio: 'App na Bio',
    blog: 'Blog',
    publish: 'Publicar',
    creatorHub: 'Hub do Criador',
    qrCodes: 'Códigos QR',
    apps: 'Apps',
    automations: 'Automações',
    messages: 'Caixa de Entrada',
    form: 'Formulários',
    embedTools: 'Embed Tools',
  },
  modal: {
    addInstagram: 'Adicionar Instagram',
    addYourInstagram: 'Adicione sua conta do Instagram',
    cropYourAvatar: 'Recortar seu avatar',
    removeSite: 'Tem certeza de que deseja remover o site?',
    areYouSure: 'Tem certeza de que deseja',
    areYouSureDelete: 'Tem certeza de que deseja excluir esta seção?',
    areYouSureArchive: 'Tem certeza de que deseja arquivar este bloco?',
    areYouSurePermanentDelete: 'Tem certeza de que deseja excluir permanentemente este bloco? Esta ação não pode ser desfeita.',
    remove: 'remover',
    site: 'site',
    removeAccountText: 'remover sua conta',
    moveBlock: 'Mover bloco para outra página',
    moveBlockText: 'Isso moverá o bloco para o final de outra página. Você pode então reorganizar o bloco na nova página',
    profileTitle: 'Alterar foto do perfil',
    profileText: 'Escolha uma imagem ou GIF do seu dispositivo.',
    profileAvatar: 'Avatar do Perfil',
    addProfilePicture: 'Adicionar Foto do Perfil',
    storiesTitle: 'Stories',
    storiesText: 'Compartilhe seus momentos do dia a dia.',
    thoughtsTitle: 'Pensamentos',
    thoughtsText: 'Compartilhe seus pensamentos.',
    accountPageDescription: 'Esta é a página da sua conta, onde você pode personalizar a aparência da sua página, adicionar diferentes blocos de recursos e muito mais.',
  },
  modalSubscribe: {
    plan: 'Plano',
    usdMonth: 'USD/mês',
    sites: 'Sites',
    sitesMuch: 'Sites',
    notification: 'Notificações',
    noNotification: 'Sem notificações ainda',
    inCategory: 'Não há itens na categoria',
    categoryYet: 'ainda.',
    externalPixels: 'Pixels Externos',
    parameters: 'parâmetros',
    analyticsReports: 'Análises e Relatórios',
    noUniLinkLogo: 'Sem Logo UniLink',
    inProfile: 'no perfil',
    verifiedBadge: 'Selo verificado',
    your: 'Seu',
    customDomain: 'domínio personalizado',
    emailMarketing: 'Email Marketing',
    liveSupport: 'Suporte ao Vivo',
    dataSecured: 'Os dados são protegidos em conformidade com o padrão PCI DSS',
    thankYou: 'Obrigado pelo seu interesse. Entraremos em contato em breve.',
    socialMediaScheduler: 'Agendador de Redes Sociais',
    featureRequest: 'Solicitação de recurso',
    markAllRead: 'Marcar tudo como lido',
    currentPlan: 'Plano Atual',
    features: 'Recursos',
  },
  buttons: {
    upgrade: 'Atualizar Plano',
    buyProPlan: 'Comprar Plano Pro',
    continue: 'Continuar',
    skip: 'Pular',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    back: 'Voltar',
    save: 'Salvar',
    add: 'Adicionar',
    added: 'Adicionado',
    done: 'Concluído',
    ok: 'OK',
    edit: 'Editar',
    delete: 'Excluir',
    remove: 'Remover',
    setAsDefault: 'Definir como padrão',
    subscribeNow: 'Assinar Agora',
    yes: 'Sim',
    preview: 'Pré-visualizar',
    generate: 'Gerar',
    changePassword: 'Alterar senha',
    deleteAccount: 'Excluir conta',
    removeAccount: 'Remover conta',
    deleteProfile: 'Excluir perfil',
    addBlock: 'Adicionar bloco',
    copyLink: 'Copiar link',
    active: 'Ativo',
    update: 'Atualizar',
    updatePro: 'Atualizar Plano',
    prev: 'Anterior',
    next: 'Próximo',
    uploadImage: 'Enviar imagem',
    uploadVideo: 'Enviar vídeo',
    loadMore: 'Carregar mais',
    uploadProductImage: 'Enviar imagem do produto',
    claim: 'Reivindicar',
    removeSite: 'Remover site',
    move: 'Mover',
    addButton: 'Adicionar botão',
    actionButton: 'Botão de ação',
    directMessage: 'Mensagem direta',
    subscribe: 'Assinar',
    button: 'Botão',
    generateWithAI: 'Gerar com IA',
    cta: 'CTA',
    cart: 'Carrinho',
    direct: 'Direto',
    follow: 'Seguir',
    addNewItem: 'Adicionar novo item',
  },
  support: {
    liveSupport: 'Suporte ao Vivo',
    response: 'Geralmente respondemos em 1 minuto durante o horário de trabalho (8h - 22h) GMT+3',
    founder: 'Denys Bilozor',
    ceo: 'Fundador e CEO da UniLink',
  },
  wizard: {
    createNewProfile: 'Criar um novo perfil',
    createProfile: 'Criar Perfil',
    continue: 'Continuar',
    tellUs: 'Conte-nos sobre você',
    addSocialLinks: 'Adicione todas as redes sociais e as mostraremos no seu banco de dados',
    addMoreLinks: 'Adicionar Mais Links',
    addLink: 'Adicionar Link',
    selectCategory: 'Selecione a categoria que melhor descreve você:',
    chooseTemplate: 'Escolha um modelo',
    skip: 'Pular',
    step: 'Passo',
    of: 'de',
    yourName: 'Seu Nome',
    search: 'Buscar',
    blog: 'Blog',
    creator: 'Criador',
    music: 'Música',
    events: 'Eventos',
    esoteric: 'Esotérico',
    fashion: 'Moda',
    influencer: 'Influenciador',
    food: 'Alimentação',
    smallBusiness: 'Pequeno Negócio',
    marketing: 'Marketing',
    education: 'Educação',
    socialMedia: 'Redes Sociais',
    coaching: 'Coaching',
    ecommerce: 'E-commerce',
    healthAndFitness: 'Saúde e Fitness',
    beautyWellness: 'Beleza e Bem-estar',
  },
  billing: {
    back: 'Voltar',
    findPlan: 'Encontre o plano ideal para você',
    changeAnytime: 'Você pode alterar a qualquer momento.',
  },
  field: {
    fullName: 'Nome Completo',
    username: 'nome de usuário',
    addValue: 'Adicionar valor',
    newValue: 'Novo valor',
    placeholderDefault: 'Texto, números, símbolos etc.',
    addInstagramUsername: 'Adicionar nome de usuário do Instagram',
    nameDefault: 'João',
    enterYourLink: 'Insira seu link',
    searchImage: 'Buscar imagem',
    pasteLink: 'Colar link',
    pasteLinkTip: 'Adicione um link para qualquer página da web',
    searchGIFs: 'Buscar GIFs',
    searchIcons: 'Buscar ícones',
    searchVideo: 'Buscar vídeo',
    search: 'Buscar',
    insertURL: 'Inserir URL',
    writeYourDescription: 'Escreva sua descrição',
    headerCTAbutton: 'Cabeçalho, botão CTA',
    enterTitle: 'Inserir título',
    enterDescription: 'Inserir descrição',
    enterURL: 'Inserir URL canônica',
  },
  tooltip: {
    addImage: 'Adicionar imagem',
    labelModalTitle: 'Configurações do rótulo',
    addLabel: '+ Adicionar rótulo',
    label: 'Rótulo',
    labelCaption: 'Inserir rótulo',
    labelText: 'Texto do rótulo',
    labelTextCaption: 'Inserir texto do rótulo',
    labelTextPlaceholder: 'Rótulo',
    labelUrl: 'URL do rótulo',
    labelUrlCaption: 'Inserir URL do rótulo',
    labelUrlPlaceholder: 'https://exemplo.com',
    noLabel: 'Sem rótulo',
    colorFrom: 'Cor de',
    colorTo: 'Cor para',
    highlight: 'Destaque',
    firstName: 'Nome',
    firstNameCaption: 'Insira seu nome',
    lastName: 'Sobrenome',
    lastNameCaption: 'Insira seu sobrenome',
    jobTitle: 'Cargo',
    jobTitleCaption: 'Insira seu cargo',
    organization: 'Organização',
    organizationCaption: 'Insira sua organização',
    email: 'E-mail',
    emailCaption: 'Insira seu e-mail',
    workPhone: 'Telefone comercial',
    workPhoneCaption: 'Insira seu telefone comercial',
    mobilePhone: 'Celular',
    mobilePhoneCaption: 'Insira seu celular',
    website: 'Site',
    websiteCaption: 'Insira seu site',
    information: 'Informação',
    informationCaption: 'Insira suas informações',
    streetAddress: 'Endereço',
    streetAddressCaption: 'Insira seu endereço',
    city: 'Cidade',
    cityCaption: 'Insira sua cidade',
    state: 'Estado',
    stateCaption: 'Insira seu estado',
    postalCode: 'CEP',
    postalCodeCaption: 'Insira seu CEP',
    country: 'País',
    countryCaption: 'Insira seu país',
    titleColor: 'Cor do título',
    titleColorCaption: 'Você pode alterar a cor do título',
    fontFamily: 'Família da fonte',
    fontFamilyCaption: 'Você pode alterar a família da fonte',
    fontSize: 'Tamanho da fonte',
    fontSizeLabel: 'Tamanho da fonte do rótulo',
    fontSizeCaption: 'Você pode alterar o tamanho da fonte',
    fontSelect: 'Fonte',
    fontSelectCaption: 'Escolha uma fonte',
    imageMargin: 'Margem da imagem',
    profilePicture: 'Foto do perfil',
    profilePictureCaption: 'Altere sua foto do perfil',
    pictureSize: 'Tamanho da foto',
    pictureSizeCaption: 'Você pode alterar o tamanho da foto',
    title: 'Título',
    titleCaption: 'Insira um título',
    blockCaption: 'Insira um título para seu bloco',
    titlePageCaption: 'Insira um título para sua página',
    templates: 'Modelos',
    templatesCaption: 'Escolha um modelo para sua página',
    background: 'Fundo',
    backgroundColor: 'Cor de fundo',
    textBackground: 'Fundo do Texto',
    textBackgroundCaption: 'Escolha a cor de fundo do texto',
    textColor: 'Cor do Texto',
    textColorCaption: 'Escolha a cor do texto',
    gradientBackground: 'Fundo Gradiente',
    gradientColor: 'Cor do Gradiente',
    BackgroundType: 'Tipo',
    backgroundSource: 'Origem do fundo',
    backgroundSourceCaption: 'Escolha a origem do fundo',
    backgroundStyle: 'Estilo do fundo',
    backgroundStyleCaption: 'Escolha o estilo do fundo',
    backgroundStylesNormal: 'Normal',
    backgroundStylesGlass: 'Vidro',
    backgroundStylesOutline: 'Contorno',
    backgroundTypeCaption: 'Escolha o tipo de fundo',
    color: 'Cor',
    colorTooltip: 'Você pode alterar a cor',
    backgroundOpacityTooltip: 'Arraste o controle para definir a opacidade do fundo',
    backgroundBlur: 'Desfoque do fundo',
    backgroundBlurCaption: 'Arraste o controle para desfocar o fundo',
    backgroundBrightness: 'Brilho do fundo',
    backgroundBrightnessCaption: 'Arraste o controle para alterar o brilho do fundo',
    backgroundContrast: 'Contraste do fundo',
    backgroundContrastCaption: 'Arraste o controle para alterar o contraste do fundo',
    color1: 'Cor 1',
    color2: 'Cor 2',
    colorCaption: 'Insira a cor da sua página',
    gradient: 'Gradiente',
    image: 'Imagem',
    photo: 'Foto',
    gif: 'GIF',
    animation: 'Animação',
    video: 'Vídeo',
    hexColor: 'Cor hexadecimal',
    direction: 'Direção',
    gradientDirection: 'Direção do gradiente',
    directionCaption: 'Arraste o controle para definir a direção do gradiente',
    offset: 'Deslocamento',
    gradientOffset: 'Deslocamento do gradiente',
    offsetCaption: 'Arraste o controle para definir o deslocamento do gradiente',
    backgroundDarkness: 'Escurecimento do fundo',
    backgroundDarknessCaption: 'Arraste o controle para escurecer a imagem de fundo',
    uploadVideo: 'Enviar vídeo',
    uploadFile: 'Enviar arquivo',
    uploadVideoCaption: 'Vídeo do fundo da sua página',
    linkToVideo: 'Link para vídeo',
    linkToVideoCaption: 'Adicionar link para vídeo',
    videoWithSound: 'Vídeo com som',
    videoWithSoundCaption: 'Reproduzir vídeo com som',
    fonts: 'Fontes',
    fontWeight: 'Peso da fonte',
    fontWeightCaption: 'Clique para escolher seu destino',
    preloader: 'Pré-carregamento',
    preview: 'Pré-visualizar',
    hideLogo: 'Ocultar logo UniLink',
    cover: 'Capa',
    coverCaption: 'Alterar capa',
    coverCaptionHeader: 'Adicionar imagem ou vídeo à capa do cabeçalho',
    pageNavigation: 'Navegação da página',
    websiteNavigation: 'Navegação por abas',
    backgroundOpacity: 'Opacidade do fundo',
    backgroundOpacityCaption: 'Arraste o controle para definir a opacidade do fundo do botão',
    borderRadius: 'Raio da borda',
    borderRadiusCaption: 'Arraste o controle para definir o raio da borda',
    heightTabs: 'Altura das abas',
    heightTabsCaption: 'Arraste o controle para definir a altura das abas',
    backgroundShadow: 'Sombra do fundo',
    backgroundShape: 'Forma do fundo',
    backgroundBorder: 'Borda do fundo',
    opacity: 'Opacidade',
    opacityCaption: 'Arraste o controle para definir a opacidade',
    shape: 'Forma',
    shapeCaption: 'Definir forma',
    text: 'Texto',
    textCaption: 'Inserir texto',
    textSize: 'Tamanho do texto',
    textSizeCaption: 'Arraste o controle para definir o tamanho do texto',
    additionalText: 'Texto adicional',
    username: 'Nome de usuário',
    currency: 'Moeda',
    language: 'Idioma',
    timeZone: 'Fuso horário',
    websiteNiche: 'Nicho do site',
    websiteNicheCaption: 'Insira o nicho do seu site',
    renameCaption: 'Renomear título do bloco',
    description: 'Descrição',
    descriptionCaption: 'Insira uma descrição',
    actionButton: 'Botão de ação',
    actionButtonCaption: 'O botão de chamada para ação motiva os visitantes a agir',
    animationDirection: 'Direção da animação',
    animationDirectionCaption: 'Escolha a direção da animação',
    buttonTitle: 'Título do botão',
    buttonTitleCaption: 'Insira o título do botão',
    buttonUrl: 'URL do botão',
    buttonUrlCaption: 'A URL abrirá em uma nova janela',
    imageSize: 'Tamanho da imagem',
    imageSizeCaption: 'Arraste o controle para definir o tamanho da imagem',
    view: 'Visualização',
    viewCaption: 'Escolha uma visualização',
    margin: 'Margem',
    marginCaption: 'Arraste o controle para adicionar margem no topo e na parte inferior do item',
    separateTopBottom: 'Topo / Inferior',
    padding: 'Espaçamento',
    paddingCaption: 'Arraste o controle para adicionar espaçamento no topo e na parte inferior do item',
    fullWidth: 'Largura total',
    lineHeight: 'Altura da linha',
    lineHeightCaption: 'Você pode alterar a altura da linha',
    button: 'Botão',
    titleSize: 'Tamanho do título',
    titleSizeCaption: 'Você pode alterar o tamanho do título',
    titleLineHeight: 'Altura da linha do título',
    titleLineHeightCaption: 'Personalize a altura da linha do título para trazer mais soluções de design ao texto',
    layout: 'Layout',
    layoutCaption: 'Crie o layout de cabeçalho que desejar',
    layoutAlign: 'Alinhamento do layout',
    alignText: 'Alinhar texto',
    align: 'Alinhar',
    alignCaption: 'Escolha o alinhamento',
    position: 'Posição',
    positionCaption: 'Escolha a posição',
    width: 'Largura',
    widthCaption: 'Escolha a largura do seu banner',
    nameHeader: 'Nome (deixe em branco para redefinir)',
    nameCaption: 'Insira o nome da sua conta',
    shortBio: 'Bio curta',
    shortBioCaption: 'Insira a bio curta da sua conta',
    externalLink: 'Link externo',
    externalLinkCaption: 'Insira o link externo da sua conta',
    location: 'Localização',
    locationCaption: 'Insira sua localização',
    locationMap: 'Mapa de localização',
    locationMapCaption: 'Insira a URL da sua localização',
    rightIcon: 'Ícone direito',
    rightIconCaption: 'Este ícone aparecerá no lado direito do botão',
    buttons: 'Botões',
    buttonsCaption: 'Adicionar botões de ação',
    nameLogo: 'Logo com nome',
    nameLogoCaption: 'Envie um logo para seu nome',
    buttonText: 'Texto do botão',
    buttonTextCaption: 'Insira o nome do seu botão',
    buttonColor: 'Cor do botão',
    buttonColorCaption: 'Escolha as cores para o botão',
    buttonColorCTACaption: 'Escolha a cor de fundo para o botão CTA',
    cartColor: 'Cor do carrinho',
    cartColorCaption: 'Escolha a cor de fundo para o carrinho',
    ctaButton: 'Botão CTA',
    ctaButtonCaption: 'Este ícone aparecerá no lado direito do botão',
    style: 'Estilo',
    socialIconsStyleCaption: 'Você pode escolher o estilo dos seus ícones sociais',
    socialIconsShape: 'Forma dos ícones sociais',
    socialIconsShapeCaption: 'Você pode escolher a forma dos ícones sociais',
    headerTextColorCaption: 'Você pode escolher a cor do texto do cabeçalho',
    pictureShape: 'Forma da foto',
    pictureShapeCaption: 'Você pode escolher a forma da foto do perfil',
    socialLinks: 'Links sociais',
    socialLinksCaption: 'Adicione botões de links sociais para conexão rápida entre você e seus clientes em um clique',
    URL: 'URL',
    URLCaption: 'Insira o endereço URL',
    heading: 'Título',
    headingTitle: 'Título do cabeçalho',
    headingTitleCaption: 'Insira o título do cabeçalho',
    headingDescription: 'Descrição do cabeçalho',
    headingDescriptionCaption: 'Insira a descrição do cabeçalho',
    headingImage: 'Imagem do cabeçalho',
    headingImageCaption: 'Envie uma imagem para o cabeçalho',
    headingPosition: 'Posição do cabeçalho',
    headingInsideBlock: 'Dentro do bloco',
    headingOutsideBlock: 'Fora do bloco',
    headingDivider: 'Divisor do cabeçalho',
    canonicalURL: 'URL Canônica',
    seo: 'SEO',
    seoCaption: 'Personalize seu produto com tags meta SEO',
    themes: 'Temas',
    brandColors: 'Cores da marca',
    applyBrandColors: 'Aplicar ao perfil',
    syncBlocks: 'Sincronizar todos os blocos',
    brandColorsApplied: 'Cores da marca aplicadas',
    generatedPalette: 'Paleta gerada',
    applying: 'Aplicando...',
    syncing: 'Sincronizando...',
    backgroundType: 'Tipo de fundo',
    palettes: 'Paletas',
    previewTitle: 'Título',
    previewTitleCaption: 'Digite o título da pré-visualização',
    previewDescription: 'Descrição',
    previewDescriptionCaption: 'Digite a descrição da pré-visualização',
    previewButton: 'Texto do botão',
    previewButtonCaption: 'Digite o texto do botão da pré-visualização',
    previewLabel: 'Texto do rótulo',
    previewLabelCaption: 'Digite o texto do rótulo da pré-visualização',
    previewThumbnail: 'Miniatura',
    previewThumbnailCaption: 'Envie a miniatura da pré-visualização',
  },
  table: {
    clicks: 'Cliques',
    signups: 'Cadastros',
    views: 'Impressões',
    orderNumber: 'Número do pedido',
    amount: 'Valor',
    credits: 'Créditos',
    invoice: 'Fatura',
    email: 'E-mail',
    card: 'Cartão',
    currency: 'Moeda',
    name: 'Nome',
    contact: 'Contato',
    optIn: 'Opt-in',
    notes: 'Notas',
    address: 'Endereço',
    date: 'Data',
    action: 'Ação',
    custom: 'Personalizado',
    status: 'Status',
    tags: 'Tags',
    view: 'Visualizar',
    remove: 'Remover',
    sendEmail: 'Enviar E-mail',
    details: 'Detalhes',
    purchases: 'Compras',
    order: 'Pedido',
    money: 'Dinheiro',
    type: 'Tipo',
    orderCode: 'Código do pedido',
  },
  settings: {
    title: 'Configurações',
    settings: 'configurações',
    accountSettings: 'Configurações da conta',
    email: 'E-mail',
    subscription: 'Assinatura',
    billingHistory: 'Histórico de cobrança',
    dueTo: 'Vencimento em',
    subscriptionDueTo: 'Assinatura vence em',
    cancelSubscription: 'Cancelar assinatura',
    cancelSubscriptionConfirm: 'Tem certeza de que deseja cancelar sua assinatura?',
    subscriptionCancelled: 'Sua assinatura foi cancelada. Seu plano permanece ativo até o final do período de cobrança.',
    subscriptionCancelError: 'Falha ao cancelar assinatura. Entre em contato com o suporte.',
    deleteFirst: 'Excluir permanentemente sua',
    deleteSecond: 'e todos os seus dados. Esta ação não pode ser desfeita.',
    account: {
      title: 'Conta',
      usernameNotAvailable: 'Nome de usuário não disponível',
      setupCustomDomain: 'Configurar domínio personalizado',
      subtitle: 'E-mail da conta, cobrança, senha e chave de API',
    },
    profile: {
      title: 'Perfil',
      usernameNotAvailable: 'Nome de usuário não disponível',
      setupCustomDomain: 'Configurar domínio personalizado',
      subtitle: 'Gerenciar nome de usuário, idioma, moeda, fuso horário',
      category: 'Categoria',
      categoryCaption: 'Insira a categoria do seu perfil',
    },
    aiassistant: {
      title: 'Assistente IA',
      subtitle: 'Personalize seu assistente IA para respostas melhores e mais personalizadas',
      titleText: 'Ajude a IA a entender quem você é para respostas mais relevantes',
      customAiTitle: 'Instruções personalizadas',
      customAiPlaceholder: 'Adicione instruções específicas para a IA...',
      customAiDescription: 'Estas instruções serão aplicadas a todas as conversas com a IA',
      nicknameTitle: 'Como a IA deve chamar você?',
      nicknamePlaceholder: 'Apelido',
      titleBio: 'Bio/ Descrição',
      bioPlaceholder: 'Conte um pouco sobre você...',
      occupation: 'O que você faz?',
      occupationPlaceholder: 'ex. Estudante de Engenharia na Universidade de São Paulo',
      aboutYouTitle: 'Sobre Você',
      aboutYouTooltip: 'Conte ao seu assistente IA um pouco sobre você',
      locationTitle: 'Localização',
      locationPlaceholder: 'ex. São Paulo, Brasil',
      categoryTitle: 'Categoria',
    },
    notifications: {
      title: 'Notificações',
      subtitle: 'Configure notificações sobre novos e-mails de visitantes e pedidos',
      text: 'Conecte mensageiros para receber notificações sobre novos e-mails e pedidos de clientes',
      setUpWebhooks: 'Configure webhooks na seção Webhooks',
      save: 'Salvar',
      connect: 'CONECTAR',
      disconnect: 'DESCONECTAR',
      webhook: 'Webhook',
      emailSubmit: 'Envio de coleta de dados',
      formSubmit: 'Envio de formulário',
      showSubmit: 'Envio da loja',
      digitalSubmit: 'Envio digital',
      appointmentSubmit: 'Envio de agendamento',
      requestSubmit: 'Envio de serviço',
      donationSubmit: 'Envio de doação',
      email: 'E-mail',
      settings: 'configurações',
      cartSubmit: 'Envio do carrinho',
      linkClick: 'Clique no link',
      contactClick: 'Clique no contato',
      all: 'Todos',
      updates: 'Atualizações',
      messages: 'Mensagens',
      opportunities: 'Oportunidades',
      insights: 'Insights',
      activity: 'Atividade',
      system: 'Sistema',
      news: 'Notícias',
      more: 'Mostrar mais',
      less: 'Mostrar menos',
      connectedAccounts: 'Contas conectadas',
      addEmailAccount: 'Adicionar conta de e-mail',
    },
    paymentSystem: {
      title: 'Sistema de pagamento',
      subtitle: 'Configure pagamentos via Stripe ou PayPal',
      text: 'Ver taxas de processamento',
      connected: 'Conectado',
      active: 'Aceitar pagamentos no site',
      pending: 'Pendente',
      disconnect: 'Desconectar',
      connect: 'Conectar',
      add: 'Adicionar',
      ofYourAccount: 'da sua conta',
      save: 'Salvar',
    },
    shop: {
      title: 'Loja',
      subtitle: 'Configuração de categorias e propriedades',
      label: {
        title: 'Rótulos',
        subtitle: 'Adicionar rótulos aos cartões de produtos',
        addValue: 'Adicionar valor',
        save: 'Salvar',
        value: 'Valor',
        enterTitle: 'Inserir título',
        maximum: 'O número máximo de valores pode ser 5',
        add: 'Adicionar',
        edit: 'Editar',
        labels: 'Rótulos',
      },
      category: {
        title: 'Categorias',
        subtitle: 'Adicionar categoria aos seus produtos',
        addCategory: 'Adicionar categoria',
        save: 'Salvar',
        maximum: 'O número máximo pode ser',
      },
      property: {
        title: 'Propriedade',
        subtitle: 'Adicionar propriedade aos seus produtos',
        addProperties: 'Adicionar propriedades',
        properties: 'Propriedades',
        type: 'Tipo',
        typeTooltip: 'Tipo das suas propriedades',
        titleModal: 'Título',
        titleModalTooltip: 'Nome das suas propriedades',
        enterTitle: 'Inserir o título',
        value: 'Valor',
        addValue: 'Adicionar valor',
        maximum: 'O número máximo de valores pode ser',
        save: 'Salvar',
        cancel: 'Cancelar',
        remove: 'Remover',
        addPropertyToItem: 'Adicionar propriedade ao item',
        add: 'Adicionar',
        edit: 'Editar',
        propertiesSmall: 'propriedades',
        required: 'Obrigatório',
        requiredTooltip: 'Definir propriedades obrigatórias para compra',
        selectAll: 'Selecionar tudo',
      },
      preorderForm: {
        title: 'Formulário de pré-venda',
        subtitle: 'Configurar campos do formulário de pré-venda',
        fields: 'Campos',
        fieldsTooltip: 'Adicionar campos ao formulário',
        required: 'Obrigatório',
        submitButton: 'Título do botão de envio',
        redirectUrl: 'URL de redirecionamento (opcional)',
        resultText: 'Texto do resultado',
        save: 'Salvar',
        name: 'Nome',
        emailAddress: 'Endereço de e-mail',
        phone: 'Telefone',
        address: 'Endereço',
        comment: 'Comentário',
      },
      shipping: {
        title: 'Entrega',
        subtitle: 'Configurar campos de entrega',
        fields: 'Campos',
        fieldsTooltip: 'Adicionar campos ao formulário de entrega',
        required: 'Obrigatório',
        save: 'Salvar',
        name: 'Nome',
        emailAddress: 'Endereço de e-mail',
        phone: 'Telefone',
        address: 'Endereço',
        comment: 'Comentário',
        addCustomField: 'Adicionar campo personalizado',
        addFormInfo: 'Adicionar informações do formulário',
        editFormInfo: 'Editar informações do formulário',
        type: 'Tipo',
        typeTooltip: 'Tipo de campo personalizado',
        fieldName: 'Nome do campo',
        fieldNameTooltip: 'Nome para campo personalizado',
        placeholder: 'Placeholder',
        placeholderTooltip: 'Placeholder para campo personalizado',
        delete: 'Excluir',
        update: 'Atualizar',
        add: 'Adicionar',
      },
    },
    seo: {
      title: 'SEO',
      subtitle: 'Personalize sua página com tags meta SEO',
      titleText: 'Título',
      titlePlaceholder: 'Insira o título da página',
      description: 'Descrição',
      descriptionPlaceholder: 'Insira a descrição da página',
      favicon: 'Favicon',
      uploadFavicon: 'Enviar favicon',
      imagePreview: 'Pré-visualização da imagem',
      useCustom: 'Usar imagem personalizada',
      save: 'Salvar',
      visualise: 'Visualize como a pré-visualização do seu site ficará no Google',
      inMessengers: 'Em mensageiros',
      inSocial: 'Em redes sociais',
      searchEngine: 'Motor de busca',
      googleIndexable: 'Indexável pelo Google',
    },
    analytics: {
      title: 'Análises',
      subtitle: 'Integre Facebook Pixel, Google Analytics e parâmetros UTM',
      facebookTooltip: 'Conecte o Facebook para exibir análises',
      googleAnalyticsTooltip: 'O Google Analytics permite medir o ROI da sua publicidade e rastrear todos os seus links.',
      googleTagManagerTooltip: 'O Google Tag Manager permite configurar e implantar tags instantaneamente no seu site',
      tikTokPixelTooltip: 'O TikTok Pixel é uma ferramenta poderosa de medição que rastreia o impacto dos seus anúncios TikTok no seu site',
      pinterestTag: 'Tag do Pinterest',
      pinterestTagTooltip:
        'A tag do Pinterest é um código que você adiciona ao seu site que permite ao Pinterest rastrear visitantes no seu site, bem como as ações que eles tomam após verem seu anúncio no Pinterest.',
      tag: 'tag',
      headerTagTooltip: 'Cole a tag que aparece no cabeçalho do seu site',
      bodyTagTooltip: 'Cole a tag que aparece no corpo do seu site',
      utmParameters: 'Parâmetros UTM',
      utmParametersTooltip: 'Colete dados de campanha com URLs personalizadas. Adicione parâmetros às URLs para identificar as campanhas que referem tráfego.',
      makeAnalytics: 'Faça o Google Analytics mostrar o tráfego do UniLink como Social',
      the: 'O',
      campaign: 'campanha',
      parameter: 'parâmetro é definido dinamicamente a partir do título de cada publicação ou link',
      save: 'Salvar',
    },
    customDomain: {
      title: 'Domínio personalizado',
      subtitle: 'Personalize sua página com domínio personalizado',
      titleTooltip: 'Adicionar domínio personalizado',
      save: 'Salvar',
      connect: 'Conectar',
      connecting: 'Conectando',
      instructions: 'Instruções',
      submit: 'Enviar',
      submitting: 'Enviando...',
      enterDomain: 'Insira seu domínio',
      domainPlaceholder: 'seu-dominio.com',
      steps: {
        submitting: 'Enviando solicitação',
        validation: 'Validação do domínio',
        certificate: 'Provisionamento do certificado',
        complete: 'Concluído',
      },
      txtRecord: {
        title: 'Registro TXT',
        description: 'Adicione o seguinte registro TXT às suas configurações DNS:',
        verifyButton: 'Verificar Registro TXT',
        verifying: 'Verificando...',
        verified: 'Registro TXT verificado',
      },
      cnameRecord: {
        title: 'Registro CNAME',
        description: 'Adicione o seguinte registro CNAME às suas configurações DNS:',
        verifyButton: 'Verificar Registro CNAME',
        verifying: 'Verificando...',
        verified: 'Registro CNAME verificado',
      },
      dnsTable: {
        type: 'Tipo',
        host: 'Host',
        value: 'Valor',
        ttl: 'TTL',
        copy: 'Copiar',
        copied: 'Copiado!',
      },
      provisioning: {
        title: 'O certificado SSL está sendo provisionado...',
        description: 'Isso pode levar alguns minutos. Por favor, aguarde.',
        timeout: 'O provisionamento do certificado está demorando mais que o esperado. Por favor, verifique mais tarde.',
      },
      complete: {
        title: 'O HTTPS foi ativado com sucesso no seu domínio.',
        connected: 'Conectado',
      },
      failed: {
        title: 'Falha na conexão do domínio',
        tryAgain: 'Tentar Novamente',
      },
      rootDomainWarning: 'Domínios raiz requerem que seu provedor DNS suporte CNAME flattening (ex.: Cloudflare, Route53).',
      deleteConfirm: {
        title: 'Desconectar domínio',
        message: 'Tem certeza de que deseja desconectar este domínio? Seu site não estará mais acessível por este domínio.',
        confirm: 'Desconectar',
        cancel: 'Cancelar',
      },
    },
    webhooks: {
      title: 'Webhooks',
      subtitle: 'Envie notificações de eventos em tempo real para serviços externos',
      webhook: 'Webhook',
      webhookTooltip: 'Adicionar webhook',
      send: 'Enviar eventos para site de terceiros',
      webhookUrl: 'URL do Webhook (requisição POST)',
      error: 'Insira um link correto',
      save: 'Salvar alterações',
      enableWebhooks: 'Ativar Webhooks',
      enableDescription: 'Requisições POST em eventos selecionados',
      endpointUrl: 'URL do Endpoint',
      endpointTooltip: 'A URL que receberá requisições POST quando os eventos selecionados ocorrerem',
      endpointPlaceholder: 'https://exemplo.com/api/webhook',
      events: 'Eventos',
      selectAll: 'Selecionar todos',
      deselectAll: 'Desmarcar todos',
      filterPlaceholder: 'Filtrar eventos...',
      all: 'Todos',
      none: 'Nenhum',
      active: 'Ativo',
      inactive: 'Inativo',
      categories: {
        submissions: 'Envios',
        engagement: 'Engajamento',
      },
      eventLabels: {
        SubmitHeaderSubscribe: 'Assinatura do Cabeçalho',
        SubmitHeaderMessage: 'Mensagem do Cabeçalho',
        SubmitDataCollect: 'Coleta de Dados',
        SubmitForm: 'Envio de Formulário',
        SubmitShop: 'Pedido da Loja',
        SubmitShopPreorder: 'Pré-venda da Loja',
        SubmitDigital: 'Produto Digital',
        SubmitAppointment: 'Agendamento',
        SubmitService: 'Pedido de Serviço',
        SubmitEvent: 'Inscrição em Evento',
        SubmitCourse: 'Inscrição em Curso',
        SubmitDonation: 'Doação',
        SubmitMembership: 'Assinatura',
        SubmitBlog: 'Compra do Blog',
        SubmitCoupon: 'Cupom Usado',
        SubmitTip: 'Gorjeta',
        SubmitLink: 'Compra de Link',
        SubmitProductMessage: 'Pergunta sobre Produto',
        SubmitPodcast: 'Compra de Podcast',
        SubmitBooking: 'Reserva',
        SubmitRental: 'Aluguel',
        SubmitSingleProduct: 'Produto Avulso',
        SubmitDiscount: 'Pedido com Desconto',
        SubmitListing: 'Solicitação de Listagem',
        SubmitUnlock: 'Desbloqueio de Conteúdo',
        SubmitChatAi: 'Mensagem do Chat IA',
        ClickLink: 'Clique no Link',
        ClickContact: 'Clique no Contato',
        AddToCart: 'Adicionar ao Carrinho',
        AddToCartSingleProduct: 'Produto Avulso ao Carrinho',
        AddToWishlist: 'Adicionar à Lista de Desejos',
        InitiateCheckout: 'Iniciar Checkout',
        DownloadFile: 'Download de Arquivo',
        DownloadMusic: 'Download de Música',
        CopyCoupon: 'Copiar Cupom',
        CopyDiscount: 'Copiar Desconto',
        QR_ScanQrCode: 'Escaneamento de QR Code',
        VisitPage: 'Visita à Página',
      },
    },
    sensitive: {
      title: 'Material sensível',
      subtitle: 'Mostrar aviso de conteúdo sensível antes de exibir seu site',
    },
    socialIntegration: {
      title: 'Integração social',
      subtitle: 'Gerencie suas integrações do Instagram, TikTok',
      connectInstagram: 'Conectar Instagram',
    },
    emailIntegration: {
      title: 'Integrações de público',
      subtitle: 'Passe os endereços de e-mail dos seus visitantes para MailChimp, Reply',
      emailCaption: 'Adicione uma integração para passar os endereços de e-mail dos seus seguidores para o MailChimp',
      mailChimp: 'Integrações MailChimp',
      selzy: 'Integrações Selzy',
      selzyCaption: 'Adicione uma chave de API para passar os endereços de e-mail dos seus seguidores para o Selzy',
      sendPulse: 'Integrações SendPulse',
      sendPulseCaption: 'Adicione uma chave de API para passar os endereços de e-mail dos seus seguidores para o SendPulse',
      reply: 'Integrações Reply',
      replyCaption: 'Adicione uma chave de API para passar os endereços de e-mail dos seus seguidores para',
      integrations: 'integrações',
    },
    calendarIntegration: {
      title: 'Calendar integrations',
      subtitle: 'Connect your calendar services',
      calendly: 'Calendly',
      calendlyDescription: 'Connect Calendly to sync your event types and availability',
      googleCalendar: 'Google Calendar',
      googleCalendarDescription: 'Connect Google Calendar to sync events and create Google Meet links',
      zoom: 'Zoom',
      zoomDescription: 'Connect Zoom to create meeting links automatically',
      googleMeet: 'Google Meet',
      googleMeetDescription: 'Create Google Meet links automatically (requires Google Calendar)',
    },
    storage: {
      title: 'Armazenamento',
      subtitle: 'Salve os pedidos dos visitantes no Google Spreadsheet',
      storageCaption: 'Adicione uma integração para salvar todos os pedidos dos clientes no Google Spreadsheet',
      emailSignup: 'Cadastro por e-mail',
      emailSignupsCaption: 'Escolha a tabela para salvar cadastros por e-mail',
      formSignups: 'Cadastro por formulário',
      forSignupsCaption: 'Escolha a tabela para salvar cadastros por formulário',
      shopOrders: 'Pedidos da loja',
      shopOrderCaption: 'Escolha a tabela para salvar pedidos da loja',
      disconnect: 'Desconectar planilha',
      storageUsage: 'Uso do armazenamento',
      of: 'de',
      uses: 'Este aplicativo usa',
      space: 'do seu espaço livre em disco',
      view: 'ver detalhes',
      noItems: 'Não há itens',
      files: 'Arquivos',
      images: 'Imagens',
      videos: 'Vídeos',
      audio: 'Áudio',
      settings: 'configurações',
    },
  },
  productStore: {
    title: 'Mostrar aba da Loja no seu link-in-bio',
    subtitle: 'Sua Loja está atualmente oculta.',
  },
  sections: {
    splashScreen: {
      title: 'Tela de Abertura',
      subtitle: 'Aparece enquanto a página está carregando',
    },
    promo: {
      title: 'Barra promocional',
      subtitle: 'Destaque que permite exibir promoções',
      masterPromoMessage:
        'A Barra Promocional Principal está ativada no momento. Se você deseja criar uma barra promocional personalizada para esta página, precisará desativar a Barra Promocional Principal primeiro.',
      titlePlaceholder: 'Bem-vindo ao meu site!',
      switcherIsMasterPromobar: 'Mostrar em todas as páginas',
    },
    contact: {
      title: 'Contatos',
      subtitle: 'Forneça formas de se comunicar com você',
      caption: 'Adicione botões de mensageiros para conexão rápida entre você e seus clientes em um clique',
      tooltip: 'Contatos permite que os usuários se comuniquem diretamente com você. Adicione seu telefone, e-mail, mensageiro ou localização',
      addNewContact: 'Adicionar novo contato',
      addContact: 'Adicionar contato',
      chooseContact: 'Escolher contato',
      enterLink: 'Insira seu link de contato',
      showDetails: 'Mostrar detalhes',
      enterAnyContact: 'Por favor, insira qualquer contato',
      enterAnyContactCaption: '(WhatsApp, Telegram, Viber, Messenger)',
    },
    membership: {
      title: 'Assinatura',
      subtitle: 'Crie uma assinatura gratuita ou paga para seu conteúdo',
      addNewTier: 'Adicionar novo nível',
      editTier: 'Editar nível',
      name: 'Nome',
      nameCaption: 'Insira o nome do seu nível',
      price: 'Preço por mês',
      priceCaption: 'Insira o preço do seu nível',
      month: 'mês',
      image: 'Imagem',
      imageCaption: 'Envie uma imagem para seu nível',
    },
    pricing: {
      title: 'Preços',
      subtitle: 'Crie um cardápio com preços',
      add: 'Adicionar novo item',
      edit: 'Editar item',
      name: 'Nome',
      nameCaption: 'Insira o nome do seu item',
      duration: 'Atributo',
      durationCaption: 'Insira o tempo, quantidade ou duração do seu item',
      category: 'Categoria',
      categoryCaption: 'Insira a categoria do seu item',
      price: 'Preço',
      priceCaption: 'Insira o preço do seu item',
      month: 'mês',
      image: 'Imagem',
      imageCaption: 'Envie uma imagem para seu item',
    },
    subscribe: {
      dataCollectTitle: 'Coleta de Dados',
      title: 'Assinar',
      subtitle: 'Colete e-mails ou números de telefone dos seus visitantes',
      instructionsMessage: 'Adicione um campo de cadastro por e-mail à sua página para que seus visitantes possam se cadastrar facilmente!',
      instructionsLink: 'Passe e-mails para o MailChimp para executar campanhas de marketing.',
      sectionHeaderCaption: 'Assine nossa newsletter',
      collecting: 'Coletando',
      collectingCaption: 'Escolha seu tipo de entrada',
      addDataToCollect: 'Adicionar dados para coleta',
      email: 'E-mail',
      enterEmail: 'Inserir e-mail',
      thanksForEmail: 'Obrigado pelo seu e-mail',
      phone: 'Telefone',
      telegram: 'Telegram',
      facebook: 'Facebook',
      instagram: 'Instagram',
      twitter: 'X (Twitter)',
      youtube: 'Youtube',
      whatsapp: 'Whatsapp',
      viber: 'Viber',
      messenger: 'Messenger',
      modalTitle: 'Adicionar links atualizados',
      placeholder: 'Placeholder',
      placeholderCaption: 'Inserir texto do placeholder',
      button: 'Botão',
      buttonCaption: 'Texto que motivará o visitante a inserir o e-mail (10% de desconto, assine agora, baixar arquivo etc.)',
      submitButton: 'Botão de envio',
      enterButton: 'Botão de entrada',
      thanksMessage: 'Mensagem de agradecimento',
      thanksMessageCaption: 'Mensagem de agradecimento dos seus assinantes',
      resultAction: 'Ação (após envio)',
      resultActionCaption: 'Ação após preenchimento do formulário',
      sendAnEmail: 'Enviar um e-mail',
      downloadFile: 'Baixar arquivo',
      redirect: 'Redirecionar',
      messageBody: 'Corpo da mensagem',
      messageBodyCaption: 'Estes dados serão enviados ao e-mail do usuário como presente pelo seu e-mail (cupom, link para download de arquivo, etc.)',
      integration: 'Integração',
      integrationCaption: 'Passe os endereços de e-mail dos seus visitantes para MailChimp, Reply',
      storage: 'Armazenamento',
      storageCaption: 'Salve os pedidos dos visitantes no Google Spreadsheet',
      maxSize: 'Você pode adicionar no máximo 3 canais',
    },
    text: {
      title: 'Texto',
      subtitle: 'Escreva qualquer coisa sobre você/empresa',
      trimBio: 'Botão Mostrar Mais',
    },
    header: {
      title: 'Cabeçalho',
      subtitle: 'Imagem ou vídeo em destaque ampliado na sua página',
      verifiedBadge: 'Selo verificado',
      showProfilePic: 'Exibir foto do perfil',
      profilePicRatio: 'Proporção',
      profilePicRatioSquare: 'Quadrado',
      profilePicRatioLandscape: 'Paisagem',
      profilePicRatioPortrait: 'Retrato',
      namePlaceholder: 'Seu nome',
      shortBioPlaceholder: 'Minhas informações resumidas',
      externalLinkPlaceholder: 'URL',
      locationPlaceholder: 'Cidade',
      addSocial: '+ Adicionar social',
      addCover: '+ Adicionar capa',
      addButton: '+ Adicionar botão',
      addText: '+ Adicionar texto',
      addLabel: '+ Adicionar rótulo',
      subtitleName: 'Personalize a aparência do seu nome',
      subtitleShortBio: 'Personalize a aparência da sua bio curta',
      shortBioSize: 'Tamanho da Bio curta',
      subtitleShortBioSize: 'Você pode alterar o tamanho da bio curta',
      subtitleLocation: 'Defina a cidade/país para navegar os visitantes para um local específico',
      headerCoverWarningMessage: 'Seu navegador não suporta a tag de vídeo.',
      headerCoverTitle: 'Definir capa acima do cabeçalho',
      coverHeight: 'Altura da capa',
      subtitleCoverHeight: 'Você pode alterar a altura da capa',
      coverDarkness: 'Escurecimento da capa',
      subtitleCoverDarkness: 'Arraste o controle para escurecer a imagem da capa',
      nameSize: 'Tamanho do nome',
      subtitleNameSize: 'Você pode alterar o tamanho do nome',
      positionText: 'Posição do nome',
      subtitlePositionName: 'Arraste o controle para definir a posição do nome',
      positionContent: 'Posição do conteúdo',
      subtitlePositionContent: 'Defina a posição para bio, link, localização',
      coverText: 'Texto na capa',
      subtitleCoverText: 'Adicione texto à sua capa',
      position: 'Posição',
      subtitlePosition: 'Arraste o controle para definir a posição do botão',
      buttonCover: 'Botão na capa',
      subtitleButtonCover: 'Adicione um botão à sua capa escolhendo uma ação',
      subtitleFollow: 'O botão Seguir permite que os usuários sigam suas novidades',
      buttonOpacity: 'Arraste o controle para alterar a opacidade do botão',
      subtitleCart: 'Ícone do carrinho para oferecer uma experiência de compra',
      subtitleDirect: 'Botão rápido para navegar o visitante aos mensageiros',
      subtitleCTAButton: '(chamada para ação) botão que motiva o usuário a clicar',
      subtitleSocialLinks: 'Dê uma aparência visual às suas redes sociais',
      chooseSocialLink: 'Escolher link social',
      alignSocialLink: 'Alinhamento dos links sociais',
      enterYourSocialLink: 'Insira seu link social',
      blockShadow: 'Sombra do bloco',
      activeButtonPosition: 'Posição do botão ativo',
      gradientColor: 'Cor do gradiente',
      bottomGradient: 'Gradiente inferior',
      autoGradient: 'Auto',
      customGradient: 'Personalizado',
      uploadLogo: 'Enviar Logo',
      customBackground: 'Fundo personalizado',
      headingLabel: 'Rótulo do Cabeçalho',
      customizeLabel: 'Personalize a aparência do rótulo do cabeçalho',
      labelText: 'Texto do Rótulo',
      enterLabelText: 'Insira o texto para o rótulo do cabeçalho',
    },
  },
  billingHistory: {
    title: 'Histórico de cobrança',
    invoices: 'Faturas',
    messageText: 'Você ainda não tem histórico de pagamentos.',
  },
  migrate: {
    title: 'Você tem LinkTree ou Taplink?',
    text: 'Cole o link e migre para o UniLink em apenas um clique!',
    button: 'Migrar',
  },
  pages: {
    title: 'Páginas',
    addPage: 'Adicionar página',
    addNewPage: 'Adicionar nova página',
    deleteTitle: 'Tem certeza de que deseja excluir esta página?',
    managePage: 'Gerenciar Abas',
    empty: 'Esta página ainda não tem nenhum bloco.',
    dragAndDrop: 'Arraste e solte suas outras abas para reordená-las',
    pageNavigation: 'Configurações de navegação da página',
    goToDesign: 'Ir para Configurações de Design',
    viewArchive: 'Ver arquivo',
    archivedBlocks: 'Blocos arquivados',
    noArchivedBlocks: 'Mantenha sua página limpa e organizada arquivando blocos que não está usando no momento.',
    archiveAllUnpublished: 'Arquivar todos os blocos não publicados',
    restore: 'Restaurar',
    permanentDelete: 'Excluir permanentemente',
  },
  analytics: {
    lifeTimeAnalytics: 'Análises Completas',
    impressions: 'Impressões',
    impressionsText: 'Desempenho das estatísticas de impressões para o período escolhido',
    clicks: 'Cliques',
    clicksText: 'Desempenho dos eventos de "clique" para o período escolhido',
    signUps: 'Cadastros',
    signUpsText: 'Desempenho dos eventos de "fechamento" para o período escolhido',
    visitor: 'Origem dos Visitantes',
    country: 'País',
    countries: 'Países',
    linkClicks: 'Cliques em links',
    content: 'Conteúdo',
    views: 'Visualizações',
  },
  aiInsights: {
    title: 'Insights de IA',
    generate: 'Analisar meu perfil',
    description: 'Receba recomendações com IA para melhorar o desempenho do seu perfil.',
    analyzing: 'Analisando seu perfil...',
    refresh: 'Atualizar',
    action: 'Ação',
  },
  post: {
    subscriptionTypePlaceholder: "Disponível para assinatura '{type}' e acima",
    postButtonText: 'Publicar',
    newPostPlaceholder: 'No que você está pensando',
    free: 'Grátis',
    pro: 'Pro',
    premium: 'Premium',
    noPost: 'Você ainda não tem publicações',
    editPost: 'Editar publicação',
  },
  preview: {
    buy: 'Comprar',
    connect: 'Conectar',
  },
  activeButton: {
    initialText: 'Site',
    inputPlaceholder: 'Buscar ações...',
    existing: 'Existente',
    redirect: 'Redirecionar',
    scroll: 'Rolar',
    title: 'Botão Ativo',
    modalTitle: 'Ação do botão ativo',
    subtitle: 'Botão que motiva o usuário a tomar uma ação',
    next: 'Próximo',
    save: 'Salvar',
    opensALinkFromLinksBlock: 'Abre um link do bloco de Links',
    url: 'URL',
    opensAWebsite: 'Abre um site',
    openInApp: 'Abrir no App',
    addAction: 'Adicionar Ação',
    actionTitle: 'Ação',
    actionCaption: 'Editar tipo de ação',
    chooseOption: 'Escolha uma opção',
    tellPeople: 'Diga às pessoas como interagir com o botão de ação',
    urlRedirect: 'Redirecionamento de URL',
    customUrl: 'URL Personalizada',
    customUrlText: 'Abre um site',
    links: 'Links',
    linksText: 'Abre um link do bloco de Links',
    downloadDocument: 'Baixar Documento',
    sendEmail: 'Enviar E-mail',
    opensEmailClient: 'Abre o cliente de e-mail',
    phoneCall: 'Chamada Telefônica',
    initiatesPhoneCall: 'Inicia uma chamada telefônica',
    navigation: 'Navegação',
    openPage: 'Abrir Página',
    opensInternalPage: 'Abre uma página interna',
    openPageText: 'Abre página interna',
    openProduct: 'Abrir Produto',
    openProductText: 'Abre página de produto da Loja',
    openBlog: 'Abrir Blog',
    opensBlogPageFromStore: 'Abre a página do blog na Loja',
    openBlock: 'Abrir Bloco',
    opensContentBlock: 'Abre o bloco de conteúdo',
    openItem: 'Abrir Item',
    opensItemPageFromStore: 'Abre a página do item na Loja',
    showNewModal: 'Mostrar Novo Modal',
    displayContentInModalWindow: 'Exibir conteúdo em janela modal',
    showProduct: 'Mostrar Produto',
    displayProductInModalWindow: 'Exibir produto em janela modal',
    showBlog: 'Mostrar Blog',
    scrollToBlock: 'Rolar até o Bloco',
    scrollToBlockText: 'Rola até o bloco especificado na página',
    scrollToItem: 'Rolar até o Item',
    action: 'Ação',
    showBlock: 'Mostrar Bloco',
    showBlockText: 'Exibe o bloco em uma janela modal na página',
    showItem: 'Mostrar Item',
    showItemText: 'Exibe o bloco do item em uma janela modal na página',
    linksCaption: 'Links',
    linksTooltip: 'Escolha um link do bloco de links',
    pagesCaption: 'Páginas',
    pagesTooltip: 'Escolha uma página das páginas',
    productsCaption: 'Produtos',
    productsTooltip: 'Escolha um produto da lista',
    blocksCaption: 'Blocos',
    blocksTooltip: 'Escolha um bloco da lista',
    itemsCaption: 'Itens',
    itemsTooltip: 'Escolha um item da lista',
    showProductText: 'Exibe o produto em uma janela modal na página',
    more: 'Mostrar mais',
    less: 'Mostrar menos',
    showNewModalTitle: 'Dados do Novo Modal',
    uploadDocumentTitle: 'Clique para enviar ou arraste e solte',
    uploadProgressTitle: 'Enviando...',
    haveNoModal: 'Você não tem modal',
    haveModal: 'Você selecionou um modal',
    openNewModalHandler: 'Criar novo modal',
    linkGroupSubTitle: 'Selecione um bloco',
    linkItemSubTitle: 'Selecione um link',
    urlItemSubTitle: 'URL do site',
    openInAppItemSubTitle: 'URL do app',
    sendEmailItemSubTitle: 'Endereço de e-mail',
    phoneCallItemSubTitle: 'Número de telefone',
    openPageGroupSubTitle: 'Selecionar Página',
    openPageItemSubTitle: 'Selecionar Página',
    openProductGroupSubTitle: 'Selecionar Tipo de Produto',
    openProductItemSubTitle: 'Selecionar Produto',
    openBlogGroupSubTitle: 'Selecionar Canal do Blog',
    openBlogItemSubTitle: 'Selecionar Artigo do Blog',
    openBlockGroupSubTitle: 'Selecionar Página',
    openBlockItemSubTitle: 'Selecionar Bloco',
    openItemGroupSubTitle: 'Selecionar Bloco',
    openItemItemSubTitle: 'Selecionar Item',
    showProductGroupSubTitle: 'Selecionar Tipo de Produto',
    showProductItemSubTitle: 'Selecionar Produto',
    showBlogGroupSubTitle: 'Selecionar Canal do Blog',
    showBlogItemSubTitle: 'Selecionar Artigo do Blog',
    showBlockGroupSubTitle: 'Selecionar Página',
    showBlockItemSubTitle: 'Selecionar Bloco',
    showItemGroupSubTitle: 'Selecionar Bloco',
    showItemItemSubTitle: 'Selecionar Item',
    scrollToBlockGroupSubTitle: 'Selecionar Página',
    scrollToBlockItemSubTitle: 'Selecionar Bloco',
    scrollToItemGroupSubTitle: 'Selecionar Bloco',
    scrollToItemItemSubTitle: 'Selecionar Item',
    linkGroupPlaceholder: 'Escolha um bloco...',
    linkItemPlaceholder: 'Escolha um link...',
    openPageItemPlaceholder: 'Escolha uma página...',
    openProductGroupPlaceholder: 'Escolha um tipo de produto...',
    openProductItemPlaceholder: 'Escolha um produto...',
    showProductGroupPlaceholder: 'Escolha um grupo de produtos...',
    showProductItemPlaceholder: 'Escolha um produto...',
    openBlogGroupPlaceholder: 'Escolha um canal de blog...',
    openBlogItemPlaceholder: 'Escolha um artigo de blog...',
    openBlockGroupPlaceholder: 'Escolha uma página...',
    openBlockItemPlaceholder: 'Escolha um bloco...',
    openItemGroupPlaceholder: 'Escolha uma página e um bloco...',
    openItemItemPlaceholder: 'Escolha um item...',
    showBlogGroupPlaceholder: 'Escolha um grupo de blog...',
    showBlogItemPlaceholder: 'Escolha um post do blog...',
    showBlockGroupPlaceholder: 'Escolha uma página...',
    showBlockItemPlaceholder: 'Escolha um bloco...',
    showItemGroupPlaceholder: 'Escolha uma página e um bloco...',
    showItemItemPlaceholder: 'Escolha um item...',
    scrollToBlockGroupPlaceholder: 'Escolha uma página...',
    scrollToBlockItemPlaceholder: 'Escolha um bloco...',
    scrollToItemGroupPlaceholder: 'Escolha uma página e um bloco...',
    scrollToItemItemPlaceholder: 'Escolha um item...',
    linkReadable: 'Link',
    urlReadable: 'URL',
    openInAppReadable: 'Abrir no app',
    downloadDocumentReadable: 'Baixar documento',
    sendEmailReadable: 'Enviar e-mail',
    phoneCallReadable: 'Ligar',
    openPageReadable: 'Abrir página',
    openProductReadable: 'Abrir produto',
    showNewModalReadable: 'Mostrar novo modal',
    showProductReadable: 'Mostrar produto',
    openBlogReadable: 'Abrir blog',
    openBlockReadable: 'Abrir bloco',
    openItemReadable: 'Abrir item',
    showBlogReadable: 'Mostrar blog',
    showBlockReadable: 'Mostrar bloco',
    showItemReadable: 'Mostrar item',
    scrollToBlockReadable: 'Rolar até o bloco',
    scrollToItemReadable: 'Rolar até o item',
  },
  design: {
    tabs: 'Abas',
    imageView: 'Visualização da imagem',
    preview: 'Pré-visualizar',
    buttonOpacity: 'Opacidade do botão',
    buttonBorder: 'Borda do botão',
    buttonShadow: 'Sombra do botão',
    itemView: 'Visualização do item',
    itemViewTooltip: 'Escolha a visualização do item',
    itemLayout: 'Layout do item',
    itemLayoutTooltip: 'Escolha o layout do item',
    top: 'Topo',
    center: 'Centro',
    bottom: 'Inferior',
    bottomLeft: 'Inferior Esquerdo',
    bottomHorizontal: 'Inferior Horizontal',
    under: 'Abaixo',
    title: 'Título',
    titleButton: 'Título e Botão',
    displayOptions: 'Opções de exibição',
    displayOptionsTooltip: 'Escolha as opções de exibição',
    landscape: 'Paisagem',
    square: 'Quadrado',
    portrait: 'Retrato',
    desktopMode: 'Modo desktop',
    mobile: 'Celular',
    desktop: 'Desktop',
    responsive: 'Responsivo',
    custom: 'Personalizado',
    templates: 'Modelos',
    chooseTemplates: 'Escolha seus modelos',
    viewAll: 'Ver todos',
    previousTheme: 'Observe que o tema anterior será apagado permanentemente.',
    useThisTemplate: 'Usar este modelo',
    notSupportedVideo: 'Seu navegador não suporta a tag de vídeo.',
    photosBy: 'Fotos por',
    animationBy: 'Animação por',
    searchTheSame: 'Pesquise o mesmo termo novamente para resultados diferentes.',
    addImage: 'Adicionar uma imagem',
    addVideo: 'Adicionar um vídeo',
    orSelectFrom: 'ou selecione de',
    noImagesYet: 'Sem imagens ainda',
    noVideosYet: 'Sem vídeos ainda',
    videoBy: 'Vídeo por',
    hamburgerMenu: 'Menu hambúrguer',
    tabsOnTop: 'Abas no topo',
    tabsOnBottom: 'Abas na parte inferior',
    borderType: 'Tipo de borda',
    subTitle: 'Escolha forma, tipo de borda, sombra etc.',
    icon: 'Ícone',
    iconTooltip: 'Escolha o ícone certo para seu botão',
    background: 'Fundo',
    color: 'Cor',
    backgroundOpacity: 'Opacidade do fundo',
    backgroundOpacityTooltip: 'Arraste o controle para definir a opacidade do fundo',
    gradient: 'Gradiente',
    color1: 'Cor 1',
    color2: 'Cor 2',
    direction: 'Direção',
    directionTooltip: 'Arraste o controle para definir a direção do gradiente',
    offset: 'Deslocamento',
    offsetTooltip: 'Arraste o controle para definir o deslocamento do gradiente',
    minHeight: 'Altura mínima',
    minHeightTooltip: 'Arraste o controle para alterar a altura mínima do botão',
    align: 'Alinhar',
    alignTooltip: 'Alterar posição do botão',
    insert: 'Inserir URL',
    upload: 'Enviar vídeo',
    search: 'Buscar vídeo',
    layout: 'Layout',
    layoutTooltip: 'Escolha o layout que desejar',
    view: 'Visualização',
    viewTooltip: 'Escolha a visualização que desejar',
    media: 'Mídia',
    mediaTooltip: 'Escolha a mídia que desejar',
    none: 'Nenhum',
    small: 'Pequeno',
    medium: 'Médio',
    large: 'Grande',
    round: 'Redondo',
    feed: 'Feed',
    slider: 'Slider',
    text: 'Texto',
    colorTooltip: 'Escolha as cores',
    button: 'Botão',
    buttonTooltip: 'Escolha as cores do botão',
    chooseEmoji: 'Escolher emoji',
    changeEmoji: 'Altere seu emoji',
    quantum: 'Quantum',
    emoji: 'Emoji',
    warp: 'Warp',
  },
  components: {
    quickAdd: {
      addLink: 'Adicionar link',
      addVideo: 'Adicionar vídeo',
      addProduct: 'Adicionar produto',
      addPost: 'Adicionar publicação',
      addArticle: 'Adicionar artigo',
      addPhoto: 'Adicionar foto',
      addMusic: 'Adicionar música',
      addFiles: 'Adicionar arquivos',
      addStory: 'Adicionar story',
    },
    emoji: {
      search: 'Buscar',
      clear: 'Limpar',
      notfound: 'Nenhum Emoji Encontrado',
      skintext: 'Escolha seu tom de pele padrão',
      categories: {
        search: 'Resultados da Busca',
        recent: 'Usados Frequentemente',
        smileys: 'Sorrisos e Emoções',
        people: 'Pessoas e Corpo',
        nature: 'Animais e Natureza',
        foods: 'Comida e Bebida',
        activity: 'Atividade',
        places: 'Viagem e Lugares',
        objects: 'Objetos',
        symbols: 'Símbolos',
        flags: 'Bandeiras',
        custom: 'Personalizado',
      },
      categorieslabel: 'Categorias de Emoji',
      skintones: {
        1: 'Tom de Pele Padrão',
        2: 'Tom de Pele Claro',
        3: 'Tom de Pele Médio-Claro',
        4: 'Tom de Pele Médio',
        5: 'Tom de Pele Médio-Escuro',
        6: 'Tom de Pele Escuro',
      },
    },
    blogPreviewModal: {
      title: 'Pré-visualização do Blog',
      notify: 'Notificar assinantes',
    },
    standAloneModal: {
      title: 'Pré-visualização do Link',
      save: 'Salvar',
      chooseLayout: 'Escolha um layout para seu link',
      linkSettings: 'Configurações do Link',
      linkSettingsSubtitle: 'Redirecionamento, aparência',
      whenVisitorsClicks: 'Quando um visitante clicar neste link:',
      redirect: 'Redirecionar',
      redirectText: 'Enviar visitantes diretamente para a URL',
      highlight: 'Destaque',
      highlightText: 'Enviar visitantes para seu UniLink e destacar',
      standalone: 'Independente',
      standaloneText: 'Destaque seu link do YouTube e reproduza o conteúdo diretamente no seu',
      cover: 'Capa',
      imageTab: 'Imagem',
      videoTab: 'Vídeo',
      uploadImage: 'Enviar imagem',
      whenVisitors: 'Quando um visitante selecionar o link compartilhado:',
      compact: 'Visualização compacta',
      fullView: 'Visualização completa',
      videoSound: 'Reproduzir vídeo com som',
    },
    instagramModal: {
      title: 'Enviar DMs automáticas no Instagram',
      subtitle: 'Envie este link via mensagem direta quando alguém comentar no seu post ou Reel do IG',
      promo: 'Escolha de qual IG você gostaria de enviar',
      connect: 'Conectar conta do Instagram',
      added: 'Conta do Instagram adicionada',
      addNew: 'Adicionar nova automação',
      igContent: 'Conteúdo do IG',
      trigger: 'Gatilho',
      dmContent: 'DM',
      linkDestination: 'Destino do Link',
      buttonTitle: 'Título do botão',
      buttonTitleTooltip: 'Insira o título do botão',
      directMessage: 'Mensagem direta',
      directMessageTooltip: 'Insira a mensagem direta',
      selectPosts: 'Selecione o post ou Reel que acionará sua DM automática.',
      onePost: 'Um post ou Reel específico',
      allPosts: 'Todos os posts ou Reels',
      triggerText: 'Quando os comentários incluírem isso, sua DM será enviada.',
      addMessage: 'Adicione uma mensagem para enviar automaticamente com seu link.',
      clickLink: 'Quando alguém clicar no link da sua DM:',
      anyComment: 'Qualquer comentário',
      specificKeywords: 'Comentários com palavras-chave específicas',
      sendLink: 'Enviar para seu UniLink e destacar ',
      skipLink: 'Pular UniLink e enviar diretamente',
      keywordsTitle: 'Comentários com palavras-chave específicas',
      keywordsText: 'Suas DMs serão enviadas quando os comentários incluírem ou excluírem\npalavras-chave específicas (sem distinção de maiúsculas e minúsculas):',
      keywordsPlaceholder: 'Digite uma palavra-chave',
      keywordsExclude: 'Excluir palavras-chave',
      keywordsExcludeText: 'Deve excluir qualquer uma destas',
      replyComment: 'Responder comentário',
      replyCommentTooltip: 'Insira a resposta ao comentário',
    },
    blockEditProduct: {
      productPreview: 'Pré-visualização do Produto',
      productDetails: 'Detalhes do Produto',
      settings: 'Configurações',
      design: 'Design',
    },
    editMenuItems: {
      overview: 'Visão Geral',
      analytics: 'Análises',
    },
    botToken: {
      bot: 'Bot',
      botTooltip: 'Insira o token do seu bot',
      connect: 'Conectar',
      token: 'Token',
    },
    rewards: {
      title: 'Título',
      titleTooltip: 'Insira o título para a resposta',
      text: 'Texto',
      textTooltip: 'Insira o texto para a resposta',
      link: 'Link',
      linkTooltip: 'Insira o link para a resposta',
      code: 'Código',
      codeTooltip: 'Insira o código para a resposta',
      files: 'Arquivos',
      filesTooltip: 'Insira os arquivos para a resposta',
      removeReward: 'Tem certeza de que deseja remover esta resposta?',
    },
    addRewardModal: {
      addReward: 'Adicionar Resposta',
      textTitle: 'Texto',
      textText: 'Dê acesso a instruções ou qualquer texto com Editor Rico',
      fileTitle: 'Arquivos',
      fileText: 'Dê acesso a arquivos e colete dados de contato',
      linkTitle: 'Link',
      linkText: 'Dê acesso a conteúdo exclusivo e colete dados de contato',
      codeTitle: 'Código',
      codeText: 'Dê acesso a promoções exclusivas e colete dados de contato',
    },
    blockEmpty: {
      isNotAdded: 'não foi adicionado',
      itSeems: 'Parece que seus',
      itemsNot: 'itens ainda não foram adicionados. Adicione seus vídeos agora',
      add: 'Adicionar',
    },
    blockList: {
      add: 'Adicionar',
      item: 'item',
    },
    submitAction: {
      action: 'Ação (após envio)',
      actionTooltip: 'Escolha uma ação após o envio',
      upload: 'Enviar anexos',
      none: 'Nenhum',
      page: 'Mostrar Página de Confirmação',
      email: 'Enviar E-mail de Confirmação',
      redirect: 'Redirecionar para URL',
    },
    blockEditItem: {
      content: 'Conteúdo',
      preview: 'Pré-visualizar',
      settings: 'Configurações',
    },
    domainButton: {
      customizeDomain: 'Personalize seu domínio.',
      upgradeToLink: 'Atualize para Link na Bio Pro e use um domínio personalizado.',
    },
    coverText: {
      text: 'Texto',
      textTooltip: 'Insira texto para sua capa',
      description: 'Descrição',
      descriptionTooltip: 'Insira a descrição para sua capa',
      textColor: 'Cor do texto',
    },
    itemModal: {
      edit: 'Editar',
      addNew: 'Adicionar novo',
      item: 'item',
      update: 'Atualizar',
      add: 'Adicionar',
    },
    viewDesign: {
      compact: 'Compacto',
      card: 'Cartão',
      button: 'Botão',
      list: 'Lista',
      hero: 'Hero',
      featured: 'Em destaque',
    },
    moveItemModal: {
      title: 'Mover item para outra página',
      cancel: 'Cancelar',
      move: 'Mover',
      page: 'Página',
      pageTooltip: 'Escolha uma página para mover o item',
      blocks: 'Blocos',
      blocksTooltip: 'Escolha um bloco para mover o item',
      emptyBlocks: 'Não há blocos necessários nesta página.',
    },
    limitModal: {
      title: 'Limite atingido',
      text1: 'Você atingiu o limite do seu site.',
      text2: 'Entre em contato conosco para atualizar seu plano.',
      close: 'Fechar',
    },
    cropPicture: {
      title: 'Recortar sua imagem',
      cancel: 'Cancelar',
      save: 'Salvar',
    },
    uploadFile: {
      uploadProductImage: 'Enviar imagem do produto',
      coverImage: 'Imagem de capa',
      uploadImages: 'Você só pode enviar imagens aqui',
    },
    userMediaLibrary: {
      addImage: 'Adicionar uma imagem',
      uploadImage: 'Enviar imagem',
      orSelectFrom: 'ou enviar',
      orSelectLink: 'ou colar link',
      myMedia: 'Minha Mídia',
      stockImages: 'Imagens de Banco',
      gifs: 'GIFs',
      icons: 'Ícones',
      noImagesYet: 'Sem imagens ainda',
      loadMore: 'Carregar mais',
    },
    itemMenu: {
      active: 'Ativo',
      willBeAvailable: 'O item estará disponível em:',
      save: 'Salvar',
      copied: 'Copiado',
      copyLink: 'Copiar link',
      delete: 'Excluir',
    },
    itemDesign: {
      linkColor: 'Cor do link',
      gradient: 'Gradiente',
      background: 'Fundo',
      backgroundOpacity: 'Opacidade do fundo',
      backgroundOpacityTooltip: 'Arraste o controle para definir a opacidade do fundo',
      backgroundDarkness: 'Escurecimento do fundo',
      backgroundDarknessTooltip: 'Arraste o controle para definir o escurecimento do fundo',
      text: 'Texto',
      color1: 'Cor 1',
      color2: 'Cor 2',
      direction: 'Direção',
      directionTooltip: 'Arraste o controle para definir a direção do gradiente',
      offset: 'Deslocamento',
      offsetTooltip: 'Arraste o controle para definir o deslocamento do gradiente',
      linkHeight: 'Altura do link',
      linkHeightTooltip: 'Arraste o controle para alterar a altura do botão',
      icon: 'Ícone',
      iconTooltip: 'Escolha o ícone para seu botão',
      imageShape: 'Forma da Imagem',
      imageShapeTooltip: 'Escolha a forma da imagem para seu link',
    },
    menu: {
      linkInBio: 'Link na bio',
      linkInBioApps: 'Link na Bio',
      audience: 'Público',
      orders: 'Pedidos',
      marketing: 'Marketing',
      emailMarketing: 'Email Marketing',
      socialPlanner: 'Planejador Social',
      shortLinks: 'Encurtador de Links',
      recentProfiles: 'Perfis Recentes',
      standalonePage: 'Página Independente',
      soloApps: 'App na Bio',
      bots: 'Bots',
      smartReply: 'Resposta Inteligente',
      analytics: 'Análises',
      settings: 'Configurações',
      shop: 'Ganhar',
      publish: 'Publicar',
      studio: 'Estúdio',
      blog: 'Blog',
      qrCodes: 'Códigos QR',
      singlePages: 'Apps',
      forms: 'Formulários',
      form: 'Formulários',
      automations: 'Automações',
      community: 'Comunidade',
      messages: 'Caixa de Entrada',
      agents: 'Agentes',
      apps: 'Apps',
    },
    notificationsBlockSetting: {
      title: 'Notificações',
      setUp: 'Configurar',
      notifications: 'notificações',
      connect: 'Conectar',
      telegramText: 'Receba notificação no Telegram quando alguém fizer',
      change: 'alteração',
      email: 'E-mail',
      emailText: 'Receba um e-mail quando alguém fizer',
      webhook: 'Webhook',
      webhookTooltip: 'Adicionar webhook',
      activate: 'Ativar',
      webhookText: 'Enviar evento para site de terceiros quando alguém fizer',
      webhookURL: 'URL do Webhook (requisição POST)',
      error: 'Insira um link correto',
      save: 'Salvar',
    },
    navigation: {
      content: 'Conteúdo',
      pages: 'Páginas',
      posts: 'Publicações',
      shop: 'Loja',
      blog: 'Blog',
      design: 'Design',
      analytics: 'Análises',
      settings: 'Configurações',
      apps: 'Apps',
      store: 'Loja',
    },
    headerSettings: {
      design: 'Design',
      analytics: 'Análises',
      settings: 'Configurações',
      editTabs: 'Editar Abas',
    },
    unlockModal: {
      title: 'Desbloqueie Recursos Pro',
      text: 'Aproveite mais do seu link-in-bio. Apenas $5/mês — desbloqueie tudo que o Pro oferece:',
      checkBoxTitle1: 'Mais Blocos:',
      checkBoxText1: 'Adicione formulários, lojas, contagens regressivas e players de mídia',
      checkBoxTitle2: 'Análises Avançadas:',
      checkBoxText2: 'Acompanhe cliques, visualizações e insights do público',
      checkBoxTitle3: 'Domínio Personalizado:',
      checkBoxText3: 'Use seu próprio domínio para um visual profissional',
      checkBoxTitle4: 'Loja Integrada:',
      checkBoxText4: 'Venda produtos e gerencie pedidos com facilidade',
      checkBoxTitle5: 'Ferramentas SEO:',
      checkBoxText5: 'Melhore seu ranking com tags meta, UTM e slugs personalizados',
      checkBoxTitle6: 'Integrações:',
      checkBoxText6: 'Sincronize com Mailchimp, Zapier e outras ferramentas',
      checkBoxTitle7: 'Email Marketing:',
      checkBoxText7: 'Colete leads e envie campanhas automatizadas',
      checkBoxTitle8: 'Suporte Prioritário:',
      checkBoxText8: 'Obtenha ajuda mais rápida sempre que precisar',
      upgradeToPro: 'Atualizar para Pro',
      viewAllPlans: 'Ver todos os planos',
    },
    profileSwitcher: {
      title: 'Todos os Perfis',
      button: 'Adicionar um novo perfil',
    },
    account: {
      signOut: 'Sair',
      createNew: 'Criar um novo Link na Bio',
      tryPro: 'Experimente o Pro agora!',
      tryProText: 'Obtenha personalização avançada e insights mais profundos do público para conseguir mais visitantes!',
    },
    accountSettings: {
      title: 'Configurações da conta',
    },
    billingHistory: {
      title: 'Histórico de cobrança',
    },
    pages: {
      home: 'Início',
      newPage: 'Nova Página',
      managePages: 'Gerenciar Páginas',
    },
    blockItem: {
      actionRequired: 'ação necessária',
    },
    blockContent: {
      untitled: 'Sem título',
      clickToRename: 'Clique para renomear o subtítulo',
      saving: 'salvando',
      saved: 'salvo',
      deleteTitle: 'Tem certeza de que deseja excluir este bloco?',
      cancel: 'Cancelar',
      yes: 'Sim',
    },
    addButtonModal: {
      title: 'Adicionar um botão de ação',
      close: 'Fechar',
      added: 'Adicionado',
      add: 'Adicionar',
      messageTitle: 'Mensagem',
      messageText: 'O botão de mensagem permite que os usuários entrem em contato com você via mensageiro',
      subscribeTitle: 'Assinar',
      subscribeText: 'O botão de assinar permite que os usuários se inscrevam na sua lista de e-mail ou mensageiro',
      ctaTitle: 'Botão CTA',
      ctaText: 'CTA é uma chamada em um site que diz ao usuário para tomar uma ação específica',
      cartTitle: 'Carrinho',
      cartText: 'Exiba um ícone de carrinho de compras para indicar que os visitantes podem fazer compras no seu site',
      contactTitle: 'Contato',
      contactText: 'Permita que os visitantes acessem rapidamente suas informações de contato',
      qrcodeTitle: 'QR Code',
      qrcodeText: 'Exiba um QR code para que os visitantes possam escanear e compartilhar sua página rapidamente',
      languageTitle: 'Idioma',
      languageText: 'Permite que os visitantes mudem o idioma da sua página',
    },
    inputMask: {
      copyLink: 'Copiar link',
    },
    videoLibrary: {
      addVideo: 'Adicionar vídeo',
      myVideos: 'Meus Vídeos',
      stockVideos: 'Vídeos de Banco',
      pasteUrl: 'Colar URL',
      uploadVideo: 'Enviar Vídeo',
    },
    createBlockModal: {
      searchTitle: 'Selecione de nossa ampla variedade de links e informações de contato abaixo.',
      title: 'Adicionar ao UniLink',
      contentTitle: 'Conteúdo',
      contentText: 'Crie e gerencie sua página',
      growTitle: 'Leads',
      growText: 'Colete leads e aumente o engajamento',
      monetizeTitle: 'Monetizar',
      monetizeText: 'Venda produtos, conteúdo e serviços',
      monetizationTitle: 'Ganhe e colete dinheiro',
      monetizationText: 'Venda produtos, serviços e colete gorjetas',
      socialTitle: 'Conteúdo de redes sociais',
      socialText: 'Compartilhe conteúdo de redes sociais no seu UniLink',
      toolsTitle: 'Ferramentas de crescimento',
      toolsText: 'Cresça, gerencie e conecte-se com seu público',
      search: 'Buscar',
      all: 'Todos',
      allCategories: 'Todas as categorias',
      content: 'Conteúdo',
      monetization: 'Monetização',
      social: 'Social',
      tools: 'Ferramentas',
      header: 'Cabeçalho',
      headerText: 'Adicione uma foto de perfil e bio',
      link: 'Links',
      linkText: 'Selecione o layout do link',
      text: 'Texto',
      textText: 'Selecione o layout do texto',
      videos: 'Vídeos',
      videosText: 'Selecione o tipo de vídeo',
      image: 'Imagem',
      imageText: 'Adicione blocos de imagem',
      music: 'Música',
      musicText: 'Selecione o tipo de música',
      socialFeeds: 'Feeds Sociais',
      socialFeedsText: 'Selecione o tipo de feed social',
      moreContent: 'Mais',
      moreContentText: 'Adicione mais blocos de conteúdo',
      dataCollect: 'Coleta de Dados',
      dataCollectText: 'Selecione o tipo de coleta de dados',
      form: 'Formulário',
      formText: 'Selecione o tipo de formulário',
      conversionTools: 'Ferramentas de engajamento',
      conversionToolsText: 'Adicione blocos de conversão',
      products: 'Produtos',
      productsText: 'Adicione blocos de produtos',
      donation: 'Gorjetas e Doações',
      tipsAndDonations: 'Gorjetas e Doações',
      tipsDonationsText: 'Blocos de gorjetas e doações',
      event: 'Evento',
      eventText: 'Selecione o tipo de evento',
      quickAdd: 'Todos os blocos',
      quickAddText: 'Adicionar qualquer bloco',
    },
    addBlockModal: {
      title: 'Adicionar ao UniLink',
      dragToAdd: 'Arraste para adicionar',
      contentTitle: 'Compartilhar conteúdo básico',
      contentText: 'Compartilhe conteúdo diretamente no seu UniLink',
      monetizationTitle: 'Ganhe e colete dinheiro',
      monetizationText: 'Venda produtos, serviços e colete gorjetas',
      socialTitle: 'Conteúdo de redes sociais',
      socialText: 'Compartilhe conteúdo de redes sociais no seu UniLink',
      toolsTitle: 'Ferramentas de crescimento',
      toolsText: 'Cresça, gerencie e conecte-se com seu público',
      search: 'Buscar',
      searchPlaceholder: 'Buscar conteúdo...',
      all: 'Todos',
      allCategories: 'Todas as categorias',
      content: 'Conteúdo',
      monetization: 'Monetização',
      social: 'Social',
      tools: 'Ferramentas',
    },
    tabNavigation: {
      tabView: 'Visualização das abas',
      tabViewTooltip: 'Selecione a visualização das abas para navegação',
      colors: 'Cores',
      colorsTooltip: 'Escolha as cores das publicações e botões',
      tabs: 'Abas',
      tabsTooltip: 'Escolha as abas exibidas na navegação do site',
      content: 'Conteúdo',
      posts: 'Publicações',
      store: 'Loja',
      shop: 'Loja',
      tabsSettings: 'Configurações de navegação por abas',
    },
    hideLogo: {
      text: 'Mostrar logo UniLink no rodapé da sua página.',
      text2: 'Mostrar logo UniLink no rodapé da sua página.',
    },
    palettePreview: {
      custom: 'Cor de Fundo Personalizada',
      hexColor: 'Cor hexadecimal',
      hexColorTooltip: 'Insira a cor hexadecimal da sua pré-visualização',
    },
    backgroundVideo: {
      insert: 'Inserir URL',
      upload: 'Enviar vídeo',
      search: 'Buscar vídeo',
    },
    periodDropdown: {
      today: 'Hoje',
      yesterday: 'Ontem',
      last7days: 'Últimos 7 dias',
      last30days: 'Últimos 30 dias',
      allTime: 'Todo o período',
      custom: 'Personalizado',
    },
    subsections: {
      content: 'Conteúdo',
      design: 'Design',
      settings: 'Configurações',
    },
    wrapperSettings: {
      lock: 'Atualizar para Plano PRO',
    },
    shareModal: {
      addSocials: 'Adicionar às Redes Sociais',
      shareTo: 'Compartilhar em',
      qrCode: 'QR code',
      customizeUrl: 'Personalizar URL',
      goToMy: 'Ir para meu',
      print: 'Você pode imprimir seu QR code exclusivo em',
      cards: 'cartões de visita e folhetos',
      download: 'Baixar',
      copy: 'Copiar',
      previewMobile: 'Pré-visualizar no celular',
      scanMobilePreview: 'Escaneie o QR code no seu celular para pré-visualizar seu site',
      types: {
        socials: 'redes sociais',
        shareTo: 'compartilhar',
        qrCode: 'QR',
        title: 'Compartilhe seu UniLink',
        titleSocials: 'Adicione UniLink às suas redes sociais',
        titleShareTo: 'Compartilhar em...',
        titleQRCode: 'QR Code',
        titlePreviewMobile: 'Pré-visualizar no Celular',
      },
      socialList: {
        instagramText: 'Adicione seu UniLink ao seu perfil do Instagram. Simplesmente copie sua URL UniLink, vá em Editar Perfil e cole no campo Site.',
        facebookText:
          'Adicione seu UniLink ao seu perfil do Facebook. Simplesmente copie sua URL UniLink, vá à página Sobre no seu perfil, clique em Informações de contato e básicas, depois clique em + Adicionar um site, cole sua URL UniLink no campo Endereço do site e clique em Salvar.',
        tikTokText:
          'Adicione seu UniLink ao seu perfil do Facebook. Simplesmente copie sua URL UniLink, vá à página Sobre no seu perfil, clique em Informações de contato e básicas, depois clique em + Adicionar um site, cole sua URL UniLink no campo Endereço do site e clique em Salvar.',
        twitchText:
          'Adicione seu UniLink ao seu canal Twitch. Simplesmente copie sua URL UniLink, vá ao seu canal Twitch, clique em Sobre, depois clique em Editar sobre e configurações de links, role até Links Sociais, adicione UniLink no primeiro campo de texto e cole sua URL UniLink no segundo campo de texto, depois clique em Adicionar.',
        youTubeText:
          'Adicione seu UniLink ao seu canal do YouTube. Simplesmente copie sua URL UniLink, vá ao seu canal do YouTube, clique em Personalizar Canal, depois clique em Informações básicas e, em Links, adicione um título de link e cole sua URL UniLink no campo URL, depois clique em Publicar.',
        linkedInText:
          'Adicione seu UniLink ao seu perfil do LinkedIn. Simplesmente copie sua URL UniLink, vá ao seu perfil do LinkedIn, clique no ícone de lápis, role até Informações de contato, cole sua URL UniLink no campo URL do site e clique em Aplicar.',
        pinterestText:
          'Adicione seu UniLink ao seu perfil do Pinterest. Simplesmente copie sua URL UniLink, vá às suas configurações do Pinterest, cole sua URL UniLink no campo URL do site e clique em Salvar.',
        twitterText:
          'Adicione seu UniLink ao seu perfil do Twitter. Simplesmente copie sua URL UniLink, vá ao seu perfil, clique em Editar Perfil e cole sua URL UniLink no campo Site.',
      },
      share: {
        shareFacebook: 'Compartilhar no Facebook',
        shareLinkedIn: 'Compartilhar no LinkedIn',
        shareTwitter: 'Compartilhar no Twitter',
        shareWhatsApp: 'Compartilhar via WhatsApp',
        shareMessenger: 'Compartilhar via Messenger',
        shareEmail: 'Compartilhar via E-mail',
      },
    },
  },
  popupMenu: {
    edit: 'Editar página',
    openInNewTab: 'Abrir em nova aba',
    copyLink: 'Copiar URL',
    delete: 'Excluir',
    showThumbnail: 'Mostrar miniaturas das páginas no painel',
    manageTabs: 'Gerenciar Abas',
  },
  tabsDashboard: {
    labelAddNewTab: 'Nova Aba',
  },
  blocks: {
    header: {
      blockTitle: 'Cabeçalho',
      blockText: 'Personalize sua foto de perfil, adicione uma bio curta e atualize seus ícones sociais',
      blockShortText: 'Personalize seu perfil',
      layout: 'Layout',
      layoutTooltip: 'Crie o layout de cabeçalho que desejar',
      layoutAlign: 'Alinhamento do layout',
      layoutAlignTooltip: 'Alinhar texto',
      profilePicture: 'Foto do perfil',
      profilePictureTooltip: 'Altere sua foto do perfil',
      pictureSize: 'Tamanho da foto',
      pictureSizeTooltip: 'Você pode alterar o tamanho da foto',
      pictureHeight: 'Altura da foto',
      pictureHeightCaption: 'Você pode alterar a altura da foto',
      preview: 'Pré-visualizar',
      badge: 'Selo',
      badgeTooltip: 'Adicionar um selo verificado ao cabeçalho',
      visibility: 'Visibilidade',
      visibilityTooltip: 'Mostrar ou ocultar a foto do perfil',
      cover: 'Capa',
      coverTooltip: 'Adicionar imagem ou vídeo à capa do cabeçalho',
      addCover: 'Adicionar capa',
      image: 'Imagem',
      video: 'Vídeo',
      positionCover: 'Posição do texto e botão',
      positionCoverTooltip: 'Arraste o controle para alterar a posição',
      buttons: 'Botões',
      block: 'Bloco',
      videoProcessing: 'Processamento de vídeo',
      vibe: 'Vibe',
      vibeTooltip: 'Adicione sua vibe',
      stories: 'Stories',
      storiesTooltip: 'Adicione seus stories',
      addStory: 'Adicionar story',
      storiesSubtitle: 'Adicione imagem ou vídeo aos seus stories',
      subscribeMethod: 'Método de assinatura',
      subscribeMethodTooltip: 'Escolha seu método de assinatura',
      subscribeLink: 'Link de assinatura',
      subscribeLinkTooltip: 'Copie seu link de assinatura',
      minWidth: 'Largura mínima',
      addVCard: 'Adicionar VCard',
      vCard: 'VCard',
      vCardTooltip: 'Você pode adicionar informações sobre você',
      buttonInline: 'Botão inline no cabeçalho',
      buttonInsideContact: 'Botão dentro do botão Contato',
      showSaveContact: 'Exibir salvar contato',
      needAddContact: 'Você precisa adicionar o botão Contato',
      socialGap: 'Espaçamento',
      socialGapCaption: 'Você pode alterar o espaçamento',
      socialSize: 'Tamanho',
      socialSizeCaption: 'Você pode alterar o tamanho',
      icons: 'Ícones',
      iconsTooltip: 'Adicionar ícone ao botão',
    },
    text: {
      blockTitle: 'Texto',
      blockText: 'Bloco de texto geral para escrever o que quiser. Você pode formatar seu texto com o editor WYSIWYG',
      blockShortText: 'Bloco de texto geral',
      title: 'Título',
      titleText: 'Personalize o tamanho do seu título',
      orderOfElements: 'Ordem dos elementos',
      orderOfElementsTooltip: 'Arraste o controle para alterar a ordem dos elementos',
      changeOrder: 'Alterar ordem',
      text: 'Texto',
      content: 'Conteúdo',
      image: 'Imagem',
      button: 'Botão',
      addButtons: 'Adicionar mais botões',
      displayedContent: 'Conteúdo exibido',
      displayedContentTooltip: 'Mostrar ou ocultar conteúdo',
      buttonLayout: 'Layout do botão',
      buttonLayoutTooltip: 'Escolha disposição vertical ou horizontal dos botões',
    },
    timeline: {
      blockTitle: 'Linha do tempo',
      blockText: 'Exiba uma linha do tempo vertical com eventos. Cada evento pode ter data/hora, título, descrição e imagem opcional',
      blockShortText: 'Exibir linha do tempo de eventos',
      editItem: 'Editar evento',
      title: 'Título',
      titlePlaceholder: 'Título do evento',
      subtitle: 'Subtítulo',
      subtitlePlaceholder: 'Cargo ou afiliação (opcional)',
      description: 'Descrição',
      descriptionPlaceholder: 'Descrição do evento (opcional)',
      startTime: 'Hora de início',
      endTime: 'Hora de término',
      startDate: 'Data de início',
      endDate: 'Data de término',
      showEndDate: 'Mostrar data de término',
      showEndDateTooltip: 'Desative para eventos em andamento (ex.: "trabalhando aqui desde 2023")',
      includeTime: 'Incluir horário',
      includeTimeTooltip: 'Se desativado, apenas a data será exibida, sem o horário',
      image: 'Imagem',
      imagePlaceholder: 'Envie um avatar ou ícone',
      imageUploadFailed: 'Não foi possível enviar a imagem. Use Minha Mídia ou cole um link.',
      untitled: 'Sem título',
      listLayout: 'Layout em lista',
      lineColor: 'Cor da linha',
    },
    trust: {
      blockTitle: 'Confiança',
      blockShortText: 'Compartilhe suas parcerias',
      blockText: 'Coloque todas as suas conexões em um só lugar.',
      titleText: 'Personalize o tamanho do seu título',
      orderOfElements: 'Ordem dos elementos',
      orderOfElementsTooltip: 'Arraste o controle para alterar a ordem dos elementos',
      changeOrder: 'Alterar ordem',
      text: 'Texto',
      content: 'Conteúdo',
      image: 'Imagem',
      button: 'Botão',
      displayedContent: 'Conteúdo exibido',
      displayedContentTooltip: 'Mostrar ou ocultar conteúdo',
      enterTrustLink: 'Insira a URL do Parceiro',
      enterTrustLinkTooltip: 'Cole a URL do Parceiro',
      enterPartnerName: 'Insira o nome do parceiro',
      enterPartnerUrl: 'https://www.seuParceiro.com/',
      enterDescription: 'Insira a descrição (opcional)',
      partnerLogo: 'Logo do Parceiro',
      uploadPartnerLogo: 'Envie o logo do seu parceiro',
    },
    link: {
      blockTitle: 'Links',
      blockText: 'Direcione tráfego para seu site, blog, loja online ou qualquer outra página da web',
      blockShortText: 'Direcione tráfego para o site',
      addLink: 'Adicionar link',
      addNewLink: 'Adicionar novo link',
      viewArchive: 'Ver arquivo',
      archivedLinks: 'Links arquivados',
      noArchivedLinks: 'Mantenha seu painel de links limpo e organizado arquivando links que não está usando no momento.',
      archiveAllUnpublished: 'Arquivar todos os links não publicados',
      addFormExisting: 'Adicionar de links existentes',
      addYourLink: 'Adicione seu link ao grupo',
      add: 'Adicionar',
      otherTypes: 'outros tipos de links',
      link: 'Link',
      navigate: 'Navegar',
      navigateTo: 'Ir para',
      scrollBlock: 'Scroll to',
      copyText: 'Copy Text',
      navigatePage: 'Página Interna',
      navigateProduct: 'Abrir Produto',
      navigateBlock: 'Navegar para Bloco',
      modal: 'Modal',
      showModal: 'Mostrar Modal',
      modalBlock: 'Mostrar Bloco',
      modalItem: 'Mostrar Item',
      modalCustom: 'Personalizado',
      document: 'Documento',
      privat24: 'Privat24',
      phone: 'Ligação Telefônica',
      viber: 'Abrir Viber',
      skype: 'Abrir Skype',
      email: 'Enviar E-mail',
      discount: 'Desconto',
      smartLink: 'Link Inteligente',
      mobileApp: 'Deep Link',
      enterURL: 'Inserir URL',
      enterPrivat: 'Insira seu cartão do Privat Bank',
      enterPhone: 'Insira o número de telefone',
      enterViber: 'Insira o número do Viber',
      enterSkype: 'Insira o Skype',
      enterEmail: 'Insira o e-mail',
      enterTitle: 'Insira o título',
      enterCopyText: 'Insira o texto a copiar',
      enterPromoCode: 'Insira o código promocional',
      group: 'Criar Grupo',
      content: 'Conteúdo',
      links: 'Links',
      heading: 'Título',
      settings: 'Configurações',
      thumbnail: 'Miniatura',
      typeTooltip: '  O clique abrirá este link',
      title: 'Título',
      titleTooltip: 'Nome do seu link',
      description: 'Descrição',
      descriptionTooltip: 'Descrição opcional de características, tipos, cor, tamanhos do link, etc.',
      label: 'Rótulo',
      labelTooltip: 'Adicionar nome do rótulo',
      button: 'Botão',
      buttonTooltip: 'Adicionar nome do botão',
      buttonText: 'Texto do botão',
      buttonTextTooltip: 'Nome do seu botão',
      buttonUrl: 'URL do botão',
      buttonUrlTooltip: 'Insira a URL do botão',
      addLinkToGroup: 'Adicionar link ao grupo',
      removeFromGroup: 'Remover do grupo',
      deletePermanently: 'Excluir Permanentemente',
      image: 'Imagem',
      buttonBg: 'Fundo do botão',
      postPreview: 'Pré-visualização da Publicação',
      separatorType: 'Tipo de separador',
      separatorTypeTooltip: 'Adicionar tipo de separador ao seu botão',
      section: 'Seção',
      sectionTooltip: 'Seção do link',
      descriptionSeparator: 'Descrição',
      descriptionSeparatorTooltip: 'Descrição opcional da seção',
      sectionText: 'Texto da seção',
      linkInstant: 'Encaminhamento instantâneo do link',
      spotlight: 'Destacar o link',
      addEffect: 'Adicionar efeito especial',
      countdown: 'Contagem regressiva',
      countdownTimer: 'Temporizador de contagem regressiva',
      countdownText: 'Adicione uma contagem regressiva ao vivo para quando seu link se tornar clicável',
      chooseDate: 'Escolher data',
      chooseDateTooltip: 'Escolha a data para seu link',
      chooseAction: 'Escolher ação',
      chooseActionTooltip: 'Escolha a ação para seu link',
      addCountdown: 'Adicionar contagem regressiva para o link',
      scheduler: 'Agendador',
      schedule: 'Agendar',
      scheduleText: 'Escolha uma data e hora no futuro para seu link ser ativado',
      activateOn: 'Ativar em',
      activateOnTooltip: 'Escolher data',
      deactivateOn: 'Desativar em',
      deactivateOnTooltip: 'Escolher data',
      addSchedule: 'Adicionar agendamento para',
      scheduleError: 'A data final não pode ser anterior à data inicial e a data inicial não pode estar no passado.',
      scheduleErrorPast: 'A data de ativação não pode estar no passado.',
      scheduleErrorPastDeactivate: 'A data de desativação não pode estar no passado.',
      scheduleErrorOrder: 'A data de desativação deve ser posterior à data de ativação.',
      activatesIn: 'Ativa em',
      deactivatesIn: 'Desativa em',
      lock: 'Bloqueio',
      lockText: 'Os visitantes só podem acessar este link cumprindo um dos critérios.',
      lockCode: 'Código',
      lockCodeTitle: 'Código para desbloquear este link',
      lockCodeText: 'Os visitantes precisam inserir um código de 4 dígitos para desbloquear este link',
      lockSubscribe: 'Assinar',
      lockSubscribeTitle: 'Os visitantes devem assinar seu UniLink para desbloquear o link.',
      lockSubscribeText: 'O bloqueio foi configurado com sucesso.',
      lockPayment: 'Pagamento',
      lockPaymentText: 'O bloqueio foi configurado com sucesso.',
      price: 'Preço',
      priceTooltip: 'Adicione o preço do seu produto',
      lockAge: 'Data de nascimento (Idade)',
      lockAgeTitle: 'Definir idade mínima',
      lockAgeText: 'Os visitantes precisam ter mais de uma certa idade para desbloquear o link com sua data de nascimento',
      lockAgeAlert: 'O bloqueio foi configurado com sucesso.',
      lockSensitive: 'Conteúdo sensível',
      lockSensitiveText: 'Os visitantes devem reconhecer que este link pode conter conteúdo inadequado para todos os públicos.',
      makeLink: 'Tornar link pagável',
      addLock: 'Adicionar bloqueio para o link',
      save: 'Salvar',
      clear: 'Limpar',
      buttonColor: 'Cor do botão',
      labelColor: 'Cor do rótulo',
      background: 'Fundo',
      imageHeight: 'Altura da imagem',
      imageHeightTooltip: 'Arraste o controle para alterar a altura da imagem',
      buttonMinimum: 'Altura mínima',
      buttonMinimumTooltip: 'Arraste o controle para alterar a altura do botão',
      textPosition: 'Posição do texto',
      textPositionTooltip: 'Escolha a posição vertical do texto',
      preview: 'pré-visualizar',
      defaultDesign: 'Design padrão',
      defaultDesignTooltip: 'Configurar design padrão para links',
      defaultDesignTitle: 'Observe que este design será aplicado a todos os links.',
      defaultDesignText: 'Você pode alterar o design padrão do link',
      changeDefault: 'Alterar padrão',
      applyDefault: 'Aplicar padrão',
      scheduled: 'Agendado',
      scheduledVisible: 'O link agendado agora está visível',
      scheduledHidden: 'O link agendado agora está oculto',
      linkClickable: 'Link clicável em',
      linkDisable: 'Link desativado em',
      lockedBy: 'Bloqueado por',
      items: 'Itens',
      doNotAnyLinks: 'Você ainda não tem nenhum link',
      sublinks: 'Sublinks',
      layout: 'Layout',
      layoutTooltip: 'Escolha o layout de sublinks que desejar',
      hideGroupLink: 'Ocultar link do grupo',
    },
    'data-collect': {
      blockTitle: 'Coleta de dados',
      blockText: 'Colete e-mails ou números de telefone dos seus visitantes',
      blockShortText: 'Coletar e-mails',
      maxSize: 'Você pode adicionar no máximo 3 canais',
      customTerms: 'Termos personalizados',
      customTermsTooltip: 'Adicionar termos personalizados ao seu formulário',
      termsConditions: 'Termos e Condições',
      text: 'Texto',
      subscribe: 'Assinar',
      title: 'Título',
      titleTooltip: 'Insira o título para os termos e condições',
      titleResultTooltip: 'Insira o título para seu envio',
      url: 'URL',
      urlTooltip: 'Insira a URL',
      editItem: 'Editar item',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Insira o texto do placeholder',
      button: 'Botão',
      buttonTooltip: 'Texto que motivará o visitante a inserir o e-mail (10% de desconto, assine agora, baixar arquivo etc.)',
      successMessage: 'Mensagem de sucesso',
      successMessageTooltip: 'Mensagem de sucesso dos seus assinantes',
      botURL: 'URL do Bot (opcional)',
      botURLTooltip: 'Insira a URL do seu bot',
      botToken: 'Token do Bot',
      botTokenTooltip: 'Insira o token do seu bot',
      rewards: 'Respostas',
      rewardsTooltip: 'Adicionar respostas dos seus assinantes',
      addReward: 'Adicionar resposta',
      thankYou: 'Mensagem de agradecimento',
      email: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta para o E-mail',
        redirect: 'Redirecionar para URL',
      },
      phone: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta para o Telefone',
        redirect: 'Redirecionar para URL',
      },
      telegram: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta no bot do Telegram',
        redirect: 'Redirecionar para URL',
      },
      whatsapp: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta no bot do WhatsApp',
        redirect: 'Redirecionar para URL',
      },
      instagram: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta no bot do Instagram',
        redirect: 'Redirecionar para URL',
      },
      messenger: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta no bot do Messenger',
        redirect: 'Redirecionar para URL',
      },
      viber: {
        none: 'Nenhum',
        display: 'Mostrar Resposta instantaneamente',
        send: 'Enviar Resposta no bot do Viber',
        redirect: 'Redirecionar para URL',
      },
      connect: 'Conectar',
      toChangeReward: 'Para alterar o tipo de resposta, você deve remover o atual',
      remove: 'Remover',
      viewTypes: 'Tipos de Visualização',
    },
    form: {
      blockTitle: 'Formulário',
      blockText: 'Permite capturar informações e dados do seu público',
      blockShortText: 'Capturar informações',
      fields: 'Campos',
      fieldsTooltip: 'Adicionar campos ao formulário',
      addCustomField: 'Adicionar campo personalizado',
      addItem: 'Adicionar item',
      editItem: 'Editar item',
      type: 'Tipo',
      typeTooltip: 'Escolha o tipo de campo',
      string: 'Resposta curta',
      textarea: 'Resposta longa',
      dropdown: 'Dropdown',
      radio: 'Radio',
      checkbox: 'Checkbox',
      date: 'Data',
      time: 'Hora',
      country: 'País',
      fieldName: 'Nome do Campo',
      fieldNameTooltip: 'Insira o nome do campo',
      name: 'Nome',
      placeholder: 'Placeholder',
      placeholderTooltip: 'Insira o texto do placeholder',
      required: 'Obrigatório',
      requiredTooltip: 'Marque se o campo é obrigatório',
      value: 'Valor',
      enterTitle: 'Insira o título',
      addValue: 'Adicionar valor',
      delete: 'Excluir',
      update: 'Atualizar',
      add: 'Adicionar',
      confirmationPage: 'Ação de confirmação',
      confirmationPageSubtitle: 'Escolha a ação resultado após envio do formulário',
      successMessage: 'Mensagem de sucesso',
      successMessageTooltip: 'Mensagem de sucesso após envio do formulário',
      thankYou: 'Mensagem de agradecimento',
      submit: 'Enviar',
    },
    contact: {
      blockTitle: 'Contatos',
      blockText: 'Contatos permite que os usuários se comuniquem diretamente com você. Adicione seu telefone, e-mail, mensageiro ou localização',
      blockShortText: 'Comunicar-se com usuários',
      addNewContact: 'Adicionar novo contato',
      newContact: 'Novo contato',
      friendlyName: 'Nome amigável',
    },
    faq: {
      blockTitle: 'FAQ',
      blockText: 'Perguntas Frequentes — usado para se referir a uma lista de respostas a perguntas típicas que os usuários podem fazer',
      blockShortText: 'Perguntas Frequentes',
      addNewItem: 'Adicionar novo item',
      editItem: 'Editar item',
      title: 'Título',
      titleTooltip: 'Insira o título',
      description: 'Descrição',
      descriptionTooltip: 'Insira a descrição',
      update: 'Atualizar',
      add: 'Adicionar',
      howToFind: 'Como nos encontrar',
    },
    ama: {
      blockTitle: 'Pergunte-me',
    },
    feature: {
      blockTitle: 'Recursos',
      blockText: 'Seção de texto com imagem para dizer aos seus usuários por que seu negócio é o melhor',
      blockShortText: 'Diga aos usuários por quê',
      title: 'Título',
      titleTooltip: 'Alterar título do item',
      description: 'Descrição',
      descriptionTooltip: 'Alterar descrição do item',
    },
    highlight: {
      blockTitle: 'Destaques',
      blockText: 'Destaque os links mais importantes com miniaturas (até 3)',
      blockShortText: 'Destaque os mais importantes',
      title: 'Título',
      titleTooltip: 'Alterar título do item',
      url: 'URL',
      urlTooltip: 'Alterar URL do item',
    },
    banner: {
      blockTitle: 'Banner',
      blockText: 'Destaque imagem, vídeo ou seu último produto. Você pode adicionar botão CTA para guiar os usuários em direção à sua meta de conversão',
      blockShortText: 'Destaque imagem, vídeo',
      height: 'Altura',
      heightTooltip: 'Alterar altura do banner',
    },
    slider: {
      blockTitle: 'Slider',
      blockText: 'Carrossel de imagens que permite exibir seu conteúdo de imagens e adicionar diferentes recursos',
      blockShortText: 'Carrossel de imagens',
      image: 'Imagem',
      imageTooltip: 'Imagem da sua galeria',
      addText: 'Adicionar texto',
      title: 'Título',
      titleTooltip: 'Título do seu slide',
      titleSize: 'Tamanho do título',
      titleSizeTooltip: 'Escolha o tamanho para melhor leitura',
      description: 'Descrição',
      descriptionTooltip: 'Descrição do seu slide',
      textColor: 'Cor do texto',
      addButton: 'Adicionar botão',
      url: 'URL',
      urlTooltip: 'URL da sua imagem',
      button: 'Botão',
      buttonTooltip: 'Título do seu botão',
      buttonText: 'Texto do botão',
      buttonColor: 'Cor do botão',
      height: 'Altura',
      heightTooltip: 'Alterar altura dos slides',
      view: 'Visualização',
      viewTooltip: 'Escolha a visualização para o slider',
      auto: 'Auto',
      square: 'Quadrado',
      rectangle: 'Retângulo',
      single: 'Único',
      multi: 'Múltiplo',
    },
    gallery: {
      blockTitle: 'Galeria',
      blockText: 'Carrossel de imagens que permite exibir seu conteúdo de imagens',
      blockShortText: 'Carrossel de imagens',
      image: 'Imagem',
      imageTooltip: 'Imagem do item da sua galeria',
      layout: 'Layout',
      layoutTooltip: 'Escolha o layout para a galeria',
      feed: 'Feed',
      slider: 'Slider',
    },
    blog: {
      blockTitle: 'Blog',
      blockText: 'Crie um blog com suas publicações',
      blockShortText: 'Criar blog',
      writeYourStory: 'Escreva sua história',
      shortDescription: 'Descrição curta',
      shortDescriptionTooltip: 'Descrição opcional para seu blog',
      description: 'Descrição',
    },
    map: {
      blockTitle: 'Mapa',
      blockText: 'Adicione o Google Maps para ajudar os usuários a navegar até seu negócio local',
      blockShortText: 'Adicionar Google Maps',
      buttonText: 'Texto do botão',
      buttonTextTooltip: 'O botão aparece quando a segunda visualização é selecionada',
      text: 'Texto',
      addAddress: 'Adicionar outro endereço',
      address: 'Endereço',
      addressTooltip: 'Cole o endereço do Google Maps, por exemplo',
      googleMap: 'Google Maps (código embed)',
      googleMapTooltip: 'Cole o código embed do Google Maps',
      howToFind: 'Como encontrar o código embed',
      incorrectCode: 'Código embed incorreto.',
      moreInfo: 'Mais informações',
      code: 'Código',
      addressSettings: 'Configurações do endereço',
      addressContent: 'Adicione URL, título e texto ou ícone do botão',
      title: 'Título',
      titleTooltip: 'O nome do seu endereço',
      url: 'URL',
      urlTooltip: 'Cole a URL do endereço do Google Maps, por exemplo',
      directionText: 'Texto de direção',
      directionTextTooltip: 'Texto de chamada para ação para seus usuários',
    },
    footer: {
      blockTitle: 'Rodapé',
      blockText: 'Seção de conteúdo na parte inferior da página. Você pode adicionar informações de contato, ícones de redes sociais e formulário de cadastro por e-mail',
      blockShortText: 'Seção de conteúdo inferior',
      addBlock: 'Adicionar bloco',
      blockType: 'Tipo de bloco',
      blockTypeTooltip: 'Escolha o tipo de bloco',
      addBlockTitle: 'Título do bloco',
      addBlockTitleTooltip: 'Escolha o título do bloco',
      faq: 'FAQ',
      'data-collect': 'Coleta de Dados',
      contact: 'Contato',
      pages: 'Páginas',
      payments: 'Pagamentos',
      social: 'Social',
      cancel: 'Cancelar',
      add: 'Adicionar',
      None: 'Nenhum',
      link: 'link',
      faqText: 'Você pode editar perguntas frequentes no bloco FAQ. Navegue até ele clicando neste',
      socialText: 'Você pode editar ícones sociais no bloco Cabeçalho. Navegue até ele clicando neste',
      dataCollectText: 'Você pode editar a coleta de dados no bloco Coleta de Dados. Navegue até ele clicando neste',
      contactText: 'Você pode editar o contato no bloco Contato. Navegue até ele clicando neste',
      pagesText: 'Você pode adicionar novas páginas no Site',
      paymentsText: 'Métodos de pagamento serão exibidos',
      showOnAllpages: 'Mostrar em todas as páginas',
      footerText: 'O Rodapé da página Inicial está ativado no momento.',
      editSocialIcons: 'Você pode editar ícones sociais na seção Cabeçalho. Navegue até ele clicando neste',
      editSubscribe: 'Você pode editar assinatura na seção Assinar. Navegue até ele clicando neste',
      editContacts: 'Você pode editar contatos na seção Contatos. Navegue até ele clicando neste',
      editFrequently: 'Você pode editar perguntas frequentes na seção FAQ. Navegue até ele clicando neste',
    },
    'chat-ai': {
      blockTitle: 'Chat IA',
      blockShortText: 'Chat com IA',
      blockText: 'Chat com IA',
      suggestionsTitle: 'Sugestões',
      suggestionsSubtitle: 'Prompts rápidos',
    },
    custom: {
      blockTitle: 'Personalizado',
      blockShortText: 'Micro app com IA',
      blockText: 'Descreva um mini app interativo e a IA gerará para você',
    },
    shop: {
      blockTitle: 'Loja',
      blockText: 'Adicione sua lista de produtos',
      blockShortText: 'Adicione seus produtos',
      view: 'Visualização',
      products: 'Produtos',
      categories: 'Categorias',
    },
    digital: {
      blockTitle: 'Produtos digitais',
      blockText: 'Venda um Download Digital: PDFs, Planilhas, Modelos, Exclusivos',
      blockShortText: 'Venda um Digital',
    },
    podcast: {
      blockTitle: 'Podcasts',
      blockText: 'Promova seus podcasts',
      blockShortText: 'Promova seus podcasts',
    },
    'page-list': {
      blockTitle: 'Lista de páginas',
      blockText: 'Crie sua lista de páginas',
      blockShortText: 'Crie sua lista de páginas',
    },
    appointment: {
      blockTitle: 'Agendamentos',
      blockText: 'Permita que visitantes agendem horários no seu calendário',
      blockShortText: 'Permita que visitantes agendem',
    },
    service: {
      blockTitle: 'Serviços',
      blockText: 'Você receberá uma notificação por e-mail quando uma solicitação for enviada a você',
      blockShortText: 'Receber um e-mail',
    },
    requests: {
      blockTitle: 'Serviços',
      blockText: 'Você receberá uma notificação por e-mail quando uma solicitação for enviada a você',
      blockShortText: 'Receber um e-mail',
    },
    tips: {
      blockTitle: 'Gorjetas',
      blockText: 'UniLink torna o apoio divertido e fácil. Em apenas alguns toques, seus fãs podem fazer o pagamento e deixar uma mensagem',
      blockShortText: 'Torna o apoio divertido',
    },
    tip: {
      blockTitle: 'Gorjetas',
      blockText: 'UniLink torna o apoio divertido e fácil. Em apenas alguns toques, seus fãs podem fazer o pagamento e deixar uma mensagem',
      blockShortText: 'Torna o apoio divertido',
    },
    donation: {
      blockTitle: 'Doações',
      blockText: 'UniLink torna o apoio divertido e fácil. Em apenas alguns toques, seus fãs podem fazer o pagamento e deixar uma mensagem',
      blockShortText: 'Torna o apoio divertido',
    },
    course: {
      blockTitle: 'Curso ou Tutorial',
      blockText: 'Permita que visitantes agendem horários no seu calendário',
      blockShortText: 'Permita que visitantes agendem',
    },
    event: {
      blockTitle: 'Eventos ou Ingressos',
      blockText: 'Permita que o público participe dos seus eventos',
      blockShortText: 'Permita que o público participe',
    },
    menu: {
      blockTitle: 'Cardápio',
      blockText: 'Crie um cardápio exclusivo com preços',
      blockShortText: 'Criar cardápio exclusivo',
    },
    booking: {
      blockTitle: 'Reservas',
      blockText: 'Permita que visitantes reservem seus espaços',
      blockShortText: 'Permita que visitantes reservem',
      name: 'Nome',
      nameCaption: 'Insira o nome do espaço',
      description: 'Descrição',
      descriptionCaption: 'Descrição curta deste espaço',
      rentalType: 'Tipo de aluguel',
      rentalTypeCaption: 'Por exemplo: apartamento, carro, escritório',
      duration: 'Duração',
      durationCaption: 'Por exemplo: por dia, por semana, por mês',
      price: 'Preço',
      priceCaption: 'Preço base deste espaço',
      oldPrice: 'Preço antigo',
      oldPriceCaption: 'Preço anterior opcional',
      rating: 'Avaliação',
      ratingCaption: 'Avaliação média (opcional)',
      label: 'Rótulo',
      labelCaption: 'Selo curto como NOVO ou DESTAQUE',
      image: 'Imagem',
      imageCaption: 'Envie uma imagem de capa para este espaço',
      location: 'Localização',
      locationCaption: 'Cidade, área ou endereço',
      capacity: 'Capacidade (hóspedes)',
      capacityCaption: 'Número máximo de hóspedes',
      rooms: 'Quartos e área',
      roomsCaption: 'Quartos, banheiros e área',
      bedrooms: 'Quartos',
      bathrooms: 'Banheiros',
      areaSqM: 'Área (m²)',
      minStay: 'Estadia mínima (dias)',
      minStayCaption: 'Número mínimo de dias para reserva',
      requiresDeposit: 'Requer depósito',
      depositAmount: 'Valor do depósito',
      depositAmountCaption: 'Depósito antecipado para confirmar reserva',
      noSmoking: 'Proibido fumar',
      noPets: 'Sem animais de estimação',
      amenitiesWifi: 'Wi-Fi',
      amenitiesParking: 'Estacionamento',
      amenitiesKitchen: 'Cozinha',
      amenitiesHeating: 'Aquecimento',
      amenitiesAC: 'Ar condicionado',
      amenitiesPool: 'Piscina',
      amenitiesSauna: 'Sauna',
      amenitiesRestrooms: 'Banheiros',
      validationNameRequired: 'Nome é obrigatório',
      validationPriceRequired: 'O preço deve ser um número não negativo',
      validationDepositRequired: 'O valor do depósito é obrigatório quando o depósito está ativado',
      validationCapacityNumber: 'A capacidade deve ser um número não negativo',
      validationOldPriceNumber: 'O preço antigo deve ser um número não negativo',
      brand: 'Marca',
      brandCaption: 'Marca do carro, ex. Tesla',
      model: 'Modelo',
      modelCaption: 'Modelo do carro, ex. Model 3',
      year: 'Ano',
      yearCaption: 'Ano de fabricação',
      color: 'Cor',
      colorCaption: 'Cor exterior, ex. preto',
      fuelType: 'Tipo de combustível',
      fuelTypeCaption: 'Gasolina, diesel, elétrico, híbrido etc.',
      transmission: 'Transmissão',
      transmissionCaption: 'Automática ou manual',
      seatCount: 'Número de assentos',
      seatCountCaption: 'Número de assentos no carro',
      edit: 'Editar item',
      add: 'Adicionar item',
    },
    membership: {
      blockTitle: 'Assinatura',
      blockText: 'Crie uma assinatura gratuita ou paga para seu conteúdo',
      blockShortText: 'Criar assinatura',
    },
    pricing: {
      blockTitle: 'Preços',
      blockText: 'Crie um cardápio exclusivo com preços',
      blockShortText: 'Criar cardápio exclusivo',
      name: 'Nome',
      nameTooltip: 'Insira o nome do seu produto',
      pricingPlanName: 'Nome do plano de preços',
      pricingPlanNameTooltip: 'Insira o nome do seu plano de preços',
      description: 'Descrição',
      descriptionTooltip: 'Insira a descrição do seu produto',
      pricingPlanDescriptionTooltip: 'Insira a descrição do seu plano de preços',
      priceValue: 'Valor do preço',
      priceUnit: 'Unidade de preço',
      label: 'Rótulo',
      labelTooltip: 'Insira o rótulo do seu plano de preços',
      orderButtonText: 'Texto do botão de pedido',
      orderButtonTextDescriptionTooltip: 'Insira o texto do botão de pedido do seu plano de preços',
      orderButtonLink: 'Link do botão de pedido',
      orderButtonLinkDescriptionTooltip: 'Insira o link do botão de pedido do seu plano de preços',
      subtitle: 'Subtítulo',
      subtitleTooltip: 'Insira o subtítulo do seu produto',
      price: 'Preço',
      priceTooltip: 'Insira o preço do seu produto',
      pricingTiers: 'Níveis de preço',
      pricingTiersTooltip: 'Insira os níveis de preço do seu produto',
      addPriceValue: 'Adicionar mais preço',
      group: 'Grupo',
      groupTooltip: 'Escolha o grupo do seu produto',
      image: 'Imagem',
      imageTooltip: 'Envie uma imagem para seu produto',
      unit: 'Unidade de preço',
      unitTooltip: 'Insira a unidade do seu preço',
      addUnitTitle: 'Unidades de preço',
      addPriceUnitValue: 'Adicionar mais unidade de preço',
      addUnitButtonText: 'Salvar',
      button: 'Botão',
      buttonTooltip: 'Adicionar botão para seu produto',
      buttonAddText: '+ Adicionar botão',
      buttonModalTextField: 'Texto do botão',
      buttonModalTextFieldTooltip: 'Insira o texto do botão',
      buttonModalURLField: 'URL do botão',
      buttonModalURLFieldTooltip: 'Insira a URL do botão',
      buttonModalTitle: 'Adicionar botão',
      groups: {
        title: 'Grupos',
        subtitle: 'Adicionar, editar e excluir grupos',
        groups: 'Grupos',
        groupsTooltip: 'Adicionar, editar e excluir grupos',
        addNewGroup: 'Adicionar novo grupo',
        newGroup: 'Novo grupo',
        titleGroup: 'Título',
        titleGroupTooltip: 'Insira o título do seu grupo',
        descriptionGroup: 'Descrição',
        descriptionGroupTooltip: 'Insira a descrição do seu grupo',
      },
    },
    menuBlock: {
      title: 'Cardápio',
      subtitle: 'Crie um cardápio com itens e preços',
      add: 'Adicionar novo item',
      edit: 'Editar item',
      name: 'Nome',
      nameCaption: 'Insira o nome do item',
      description: 'Descrição',
      descriptionCaption: 'Insira uma descrição curta',
      ingredients: 'Ingredientes',
      ingredientsCaption: 'Liste os ingredientes ou composição',
      price: 'Preço',
      priceCaption: 'Insira o preço',
      weight: 'Peso (g)',
      weightCaption: 'Insira o peso em gramas',
      calories: 'Calorias (kcal)',
      caloriesCaption: 'Insira as calorias em kcal',
      label: 'Rótulo',
      labelCaption: 'Insira o texto do rótulo',
      labelColor: 'Cor do rótulo',
      labelColorCaption: 'Escolha uma cor de fundo para o rótulo',
      image: 'Imagem',
      imageCaption: 'Envie uma imagem para seu item',
      available: 'Disponível para pedido',
      visible: 'Visível na página',
    },
    nft: {
      blockTitle: 'NFT',
      blockText: 'Exiba um NFT da plataforma OpenSea',
      blockShortText: 'Exibir um NFT',
    },
    wallet: {
      wallet: 'Carteira',
      blockTitle: 'Carteira Bancária/Cripto',
      blockText: 'Exiba seu Cartão de Crédito ou carteira Bitcoin para facilitar a cópia pelos usuários para transferência de fundos',
      blockShortText: 'Exiba suas carteiras',
      title: 'Título',
      titleTooltip: 'Título da sua carteira',
      walletNumber: 'Número da carteira',
      walletNumberTooltip: 'Cole o número da sua carteira',
      icon: 'Ícone',
      iconTooltip: 'Definir ícone para sua carteira',
      card: 'Cartão',
      bank: 'Banco',
      crypto: 'Cripto',
      transfer: 'Transferência',
      paymentLink: 'Link de pagamento',
      cardNumber: 'Número do cartão',
      cardNumberTooltip: 'Cole o número do seu cartão',
      cardHolder: 'Titular do cartão',
      cardHolderTooltip: 'Insira o titular do seu cartão',
      bankAccountDetails: 'Dados da conta bancária',
      bankAccountDetailsTooltip: 'Insira os dados da sua conta bancária',
      walletAddress: 'Endereço da carteira',
      walletAddressTooltip: 'Insira o endereço da sua carteira',
      network: 'Rede',
      networkTooltip: 'Insira sua rede',
      publicKey: 'Chave pública',
      publicKeyTooltip: 'Insira sua chave pública',
      providerName: 'Nome do provedor',
      providerNameTooltip: 'Insira o nome do seu provedor',
      link: 'Link',
      linkTooltip: 'Insira seu link',
      serviceName: 'Nome do serviço',
      serviceNameTooltip: 'Insira o nome do seu serviço',
      email: 'E-mail',
      emailTooltip: 'Insira seu e-mail',
      phone: 'Telefone',
      phoneTooltip: 'Insira seu telefone',
      username: 'Nome de usuário',
      usernameTooltip: 'Insira seu nome de usuário',
      fullName: 'Nome completo',
      fullNameTooltip: 'Insira seu nome completo',
      referenceNumber: 'Número de referência',
      referenceNumberTooltip: 'Insira seu número de referência',
      country: 'País',
      countryTooltip: 'Insira seu país',
      transferProvider: 'Provedor de transferência',
      transferProviderTooltip: 'Insira seu provedor de transferência',
      cryptoCurrency: 'Criptomoeda',
      cryptoCurrencyTooltip: 'Insira sua criptomoeda',
    },
    instagram: {
      blockTitle: 'Instagram',
      blockText: 'Destaque sua melhor mídia e vídeo do Instagram ou venda seus produtos com um feed de compras do Instagram',
      blockShortText: 'Sua melhor mídia do Instagram',
      blockConnectTitle: 'Instagram não está conectado',
      blockConnectText: 'Parece que seus produtos do Instagram ainda não foram importados. Conecte sua conta agora',
      blockConnectButton: 'Adicionar Instagram',
      emptyList: 'Você ainda não tem mídia do Instagram.',
      addInstagramUsername: 'Adicionar nome de usuário do Instagram',
      username: 'Nome de usuário',
      downloadTakes: 'O download leva até 2 minutos',
      displayPost: 'Exibir publicação no seu site',
      view: 'Visualizar',
      redirect: 'Redirecionamento de URL',
      text: 'Texto e Botão',
      actionType: 'Tipo de ação',
      url: 'URL',
      openInNewTab: 'Abrir em nova aba',
      delete: 'Excluir',
      cancel: 'Cancelar',
      save: 'Salvar',
      editMedia: 'Editar Mídia',
      title: 'Título',
      automation: 'Automação',
      automationText: 'Automatize sua conta com recursos de Piloto Automático',
      autopilot: 'Piloto Automático',
      autopilotTooltip: 'Envie uma publicação com a legenda de exemplo e suas tags de produtos/links serão gerados automaticamente',
      switchTitle: 'Detectar automaticamente título, preço, links',
      sampleCaption: 'Legenda de exemplo: #49.99 #VestidoLindo https://google.com',
      integrations: 'Integrações',
      integrationsText: 'Adicione Instagram ao seu site',
      connectInstagram: 'Conectar Instagram',
      connectInstagramText: 'Conecte sua conta do Instagram para exibir as publicações ou reels de sua escolha.',
      selectAccount: 'Selecionar conta',
      connectNewInstagram: 'Conectar uma nova conta do Instagram',
      continue: 'Continuar',
      disconnectInstagram: 'Desconectar Instagram',
      addTag: 'Adicionar tag',
      tagClickHint: 'Clique na imagem para posicionar a tag',
      tagPositionSet: 'Posição definida. Preencha os detalhes abaixo.',
      tagTypeLink: 'Link',
      tagTypeProduct: 'Produto',
      tagLabel: 'Rótulo',
      tagSelectProduct: 'Selecionar produto',
    },
    tiktok: {
      blockTitle: 'TikTok',
      blockText: 'Destaque seu melhor vídeo do TikTok ou venda seus produtos com um feed de compras do TikTok',
      blockShortText: 'Seu melhor vídeo do TikTok',
      addTikTok: 'Adicionar conta TikTok',
      individualVideo: 'Vídeo individual',
      videoCollection: 'Coleção de vídeos',
      add: 'Adicionar',
      blockConnectTitle: 'TikTok não está conectado',
      blockConnectText: 'Parece que seus produtos do TikTok ainda não foram importados. Conecte sua conta agora',
      blockConnectButton: 'Conectar TikTok',
      enterUsername: 'Insira o nome de usuário',
      enterVideo: 'Insira a URL de um vídeo do TikTok',
      emptyList: 'Você ainda não tem mídia do TikTok.',
      editMedia: 'Editar Mídia',
      addTikTokVideo: 'Adicionar vídeo do TikTok',
      displayPost: 'Exibir publicação no seu site',
      delete: 'Excluir',
      cancel: 'Cancelar',
      save: 'Salvar',
      integrations: 'Integrações',
      integrationsText: 'Adicione TikTok ao seu site',
      connectTikTok: 'Conectar TikTok',
      disconnectTikTok: 'Desconectar TikTok',
      individualText: "Você não pode conectar a conta TikTok a este tipo de bloco ('individual').",
      individualText2: 'Por favor, adicione um único vídeo do TikTok em vez disso.',
    },
    youtube: {
      blockTitle: 'YouTube',
      blockText: 'Destaque um vídeo ou transmissão do YouTube na sua página. Marque produtos no vídeo do YouTube',
      blockShortText: 'Destaque um vídeo do YouTube',
      enterYouTubeLink: 'Insira a URL do YouTube',
      enterYouTubeLinkTooltip: 'Cole a URL do YouTube',
    },
    overview: {
      blockTitle: 'Visão Geral',
      blockText: 'Destaque um vídeo ou transmissão na sua página. Marque produtos no vídeo',
      blockShortText: 'Marque produtos no vídeo',
    },
    video: {
      blockTitle: 'Vídeo',
      blockText: 'Destaque um vídeo ou transmissão na sua página. Marque produtos no vídeo',
      blockShortText: 'Destaque um vídeo',
    },
    twitter: {
      blockTitle: 'X (Twitter)',
      blockText: 'Exiba seus Tweets na sua página UniLink para aumentar o engajamento',
      blockShortText: 'Exiba seus Tweets',
      twitterURL: 'URL do Twitter',
      twitterURLTooltip: 'Adicione a URL do Twitter para gerar o código incorporado',
      enterTwitterURL: 'Insira a URL do Twitter',
    },
    music: {
      blockTitle: 'Música',
      blockText: 'Incorpore músicas do Spotify, SoundCloud, playlist ou envie seu próprio arquivo de áudio',
      blockShortText: 'Adicionar sua música',
      brand: 'Marca',
      brandTooltip: 'Escolha o tipo para adicionar sua música',
      url: 'URL',
      embed: 'Código embed',
      custom: 'Personalizado',
      musicUrl: 'URL da música',
      musicUrlTooltip: 'Insira a URL da música',
      embedCodeTitle: 'Código embed',
      embedCodeTooltip: 'Cole o código embed da sua música da plataforma escolhida',
      audioFile: 'Arquivo de áudio',
      uploadAudios: 'Você só pode enviar áudio aqui',
      title: 'Título',
      titleTooltip: 'Insira o título da sua música',
      artist: 'Artista',
      artistTooltip: 'Insira o artista da sua música',
      audioFileTitle: 'Arquivo de áudio',
      audioFileTooltip: 'Nome do seu arquivo de áudio',
      coverImage: 'Imagem de capa',
      coverImageTooltip: 'Envie uma imagem para sua música',
    },
    twitch: {
      blockTitle: 'Twitch',
      blockText: 'Incorpore vídeo ou transmissão do Twitch na sua página',
      blockShortText: 'Incorporar vídeo do Twitch',
      twitchURL: 'URL do Twitch',
      twitchURLTooltip: 'Cole a URL do canal ou nome do canal',
      twitchTV: 'twitch.tv/...',
      displayTwitch: 'Exibir meu canal Twitch',
      displayChat: 'Exibir meu canal Twitch e chat',
    },
    splash: {
      blockTitle: 'Tela de abertura',
      blockText: 'Banner em tela cheia com texto e botão que aparece antes do carregamento do site para promover qualquer produto ou evento',
      blockShortText: 'Banner em tela cheia',
    },
    promo: {
      blockTitle: 'Barra promocional',
      blockText: 'Destaque que permite exibir promoções',
      blockShortText: 'Destaque suas promoções',
    },
    welcome: {
      blockTitle: 'Mensagem de boas-vindas',
      blockText:
        'Escreva mensagens de boas-vindas que convidam os visitantes a iniciar uma conversa. Aparece na parte inferior da página para receber visitantes e oferecer assistência',
      blockShortText: 'Escreva mensagens de boas-vindas',
    },
    review: {
      blockTitle: 'Avaliações',
      blockText: 'Avaliações ajudam os clientes a aprender mais sobre o produto e decidir se é o produto certo para eles',
      blockShortText: 'Avaliações ajudam clientes',
      name: 'Nome',
      nameTooltip: 'Insira o nome do avaliador',
      comment: 'Comentário',
      commentTooltip: 'Insira o comentário do avaliador',
      date: 'Data',
      dateTooltip: 'Insira a data da avaliação',
      rate: 'Nota',
      rateTooltip: 'Definir nota da avaliação',
      image: 'Imagem',
      imageTooltip: 'Enviar imagem do avaliador',
    },
    coupon: {
      blockTitle: 'Cupons',
      blockText: 'Um cupom online refere-se a um código de desconto ou número que pode ser resgatado em um site',
      blockShortText: 'Cupom online refere-se',
    },
    timer: {
      blockTitle: 'Temporizador',
      blockText:
        'Um temporizador de contagem regressiva é um relógio virtual em uma página que conta de um certo número ou data para indicar o início ou fim de um evento ou oferta',
      blockShortText: 'Temporizador de contagem regressiva',
    },
    outfit: {
      blockTitle: 'Looks',
      blockText: 'Crie sua própria lista de produtos',
      blockShortText: 'Criar lista de produtos',
    },
    spacer: {
      blockTitle: 'Espaçador',
      blockText: 'Adicione espaço vertical vazio à sua página',
      blockShortText: 'Adicione espaço vazio',
    },
    html: {
      blockTitle: 'Código HTML',
      blockText:
        'Você pode colar seu próprio código HTML na página UniLink. HTML é uma linguagem de marcação padrão para criação de páginas web. Permite iframes, seções, parágrafos e links.',
      blockShortText: 'Cole seu próprio HTML',
      markupCode: 'Código de marcação',
      markupCodeTooltip: 'Cole o código de marcação do seu HTML',
    },
    unlock: {
      blockTitle: 'Desbloquear',
      blockText: 'Você pode adicionar seu conteúdo desbloqueável à página UniLink.',
      blockShortText: 'Cole seu arquivo desbloqueável',
    },
    file: {
      blockTitle: 'Arquivo',
      blockText:
        'Este bloco permite enviar e compartilhar arquivos como documentos, imagens ou áudio. Os visitantes podem facilmente visualizar ou baixá-los diretamente da sua página.',
      blockShortText: 'Envie e compartilhe seus arquivos.',
      addNewItem: 'Adicionar novo arquivo',
      editFile: 'Editar Arquivo',
      fileName: 'Insira o nome do arquivo',
    },
    stat: {
      blockTitle: 'Estatísticas',
      blockText:
        'Este bloco permite exibir insights importantes sobre sua página, como visualizações, visitantes ou engajamento. Ajuda você a monitorar seu público e entender o desempenho da sua página.',
      blockShortText: 'Adicionar estatísticas à sua página.',
      addNewItem: 'Adicionar nova estatística',
      editItem: 'Editar estatística',
      statName: 'Insira o nome da estatística',
      statValue: 'Insira o valor da estatística',
      statDescription: 'Insira a descrição da estatística',
      statItemFields: 'Selecione os campos para exibir.',
      feed: 'Feed',
      slider: 'Slider',
      titleSize: 'Tamanho do título',
      subtitleTitleSize: 'Você pode alterar o tamanho do título',
    },
    listing: {
      blockTitle: 'Listagem',
      blockText: 'Exiba imóveis ou anúncios de itens com imagens, detalhes e preços.',
      blockShortText: 'Adicione listagens à sua página.',
    },
    rental: {
      blockTitle: 'Aluguel',
      blockText: 'Liste imóveis ou itens para alugar com disponibilidade e preços por período.',
      blockShortText: 'Adicione aluguéis à sua página.',
    },
    'single-product': {
      blockTitle: 'Produto único',
      blockText: 'Destaque um único produto com imagem, descrição e botão de compra.',
      blockShortText: 'Destaque um produto.',
    },
    team: {
      blockTitle: 'Equipe',
      blockText: 'Apresente os membros da sua equipe com fotos, nomes, cargos e redes sociais.',
      blockShortText: 'Mostre sua equipe.',
    },
    timetable: {
      blockTitle: 'Agenda',
      blockText: 'Exiba uma agenda semanal com aulas, eventos ou sessões.',
      blockShortText: 'Adicione uma agenda semanal.',
    },
  },
};
